<template>
  <div class="p-re w100">
    <Login  style="z-index: 9999"
      :isLogin="isLogin"
      :logBoolean="logBoolean"
      :editBoolean="editBoolean"
      :gotUserinfo="userinfo"
      @changeLoginStatus="changeLoginStatus"
      @getuserinfo="getuserinfo"
      @editBooleanReceived="editBooleanReceived"
    ></Login>

    <div class="w100 h100BgBox flexcc" v-if="changeStorePopup">
      <div class="p-re whiteBg flexcc flex-column w90Mobile">
        <img src="@/assets/note.png" class="w50 w90Mobile" alt="" />
        <div class="color2 cText bold center mt30">
          If you change store, your cart will be cleared.
        </div>
        <div class="w100 flex-around mt40 maxwidth300">
          <div class="btn btnDefalt" @click="changeStorePopup = false">
            Cancel
          </div>
          <div class="btn">
            <div @click="goHome()" style="color: #fff"
              >Confirm</div
            >
          </div>
        </div>
      </div>
    </div>
    <div class="w100 h100BgBox flexcc" v-if="pointUpPopup">
      <div class="p-re whiteBg flexcc flex-column w90Mobile">
        <img src="@/assets/upgraded.png" class="w50 w90Mobile" alt="" />
        <div class="color2 cText bold center mt30">
          Congratulations, your level has been upgraded to
          {{ userPtsObj.levelname }}
        </div>
        <div class="w100 flex-around mt40 maxwidth300">
          <!-- <div class="btn btnDefalt" @click="changeStorePopup=false">Cancel</div> -->
          <div class="btn" @click="pointUpPopup = false">Confirm</div>
        </div>
      </div>
    </div>
    <div
      class="flex flexc2 flex-between w100 signWhiteBg"
      :class="onlyUser ? '' : 'pt10'"
    >
      <div v-if="onlyUser"></div>
      <div class="flexc2 nowrap wrapNameM" v-if="!onlyUser">
        <div>{{ storeObj.storename }}</div>
        <div @click="changeStore" class="csBtn flexc2 cp">Change Store</div>
        <!-- <router-link to="/chooseLocation" class="csBtn flexc2 cp"
          >Change Store</router-link
        > -->
      </div>

      <div class="tBox2 color2 flexc2 mWauto" :class="onlyUser ? 'mr15' : ''">
        <div
          class="cp flexc2"
          @click="isLogin = checkLogin()"
          style="white-space: nowrap; margin-right: 10px"
        >
          <span v-if="isLogin != 1 || !isLogin" class="cp"
            >Sign up / Log In</span
          >
        </div>
        <div v-if="userinfo && userinfo.nickname">
          <el-popover
            placement="bottom"
            :visible-arrow="false"
            popper-class="popperClass"
            trigger="click"
          >
            <div class="center popcontent">
              <a
                >{{ userPtsObj.levelname }} Level
                <p class="fs18 bolder">{{ userPtsObj.pts }}</p>
                <p class="fs12">Points</p></a
              >
              <!-- <div>Setting</div> -->
              <!-- <a class="cp" @click="linkToOrders">My Order</a> -->
              <router-link to="/center/orderList">My Order</router-link>
              <!-- <router-link to="/center/orderList">Log Out</router-link> -->
              <div @click="logout" class="cp">Log Out</div>
            </div>
            <div slot="reference">
              <div
                class="cp flexc2"
                v-if="getStorage() && userinfo && userinfo.nickname"
              >
                <img
                  :src="
                    userinfo.gender
                      ? require('@/assets/female.png')
                      : require('@/assets/male.png')
                  "
                  alt=""
                  style="width: 25px"
                />
                <span style="padding: 0 20px; white-space: nowrap">{{
                  userinfo.nickname
                }}</span>
              </div>
            </div>
          </el-popover>
        </div>
        <div class="p-re mWauto" v-if="!onlyUser">
          <img
            src="@/assets/cart-1.png"
            alt=""
            class="cartIcon cp"
            @click="cartBoolean = true"
          />
          <div class="cartNumBox flexcc">
            {{ cartNumber }}
          </div>
        </div>
      </div>
    </div>
    <div class="" v-if="!onlyUser">
      <el-drawer
        title="购物车"
        direction="rtl"
        :wrapperClosable="true"
        :visible.sync="cartBoolean"
        @closed="changeFatherCartBoolean"
        custom-class="cartDrawer"
        size="100%"
        :append-to-body="true"
        :modal-append-to-body="true"
        :with-header="false"
      >
        <div class="flex flex-between cartTopBox">
          <div class="flexc2 cp" @click="setCartEmpty()">
            <img src="@/assets/clean.png" alt="" class="cleanIcon" />
            <p class="">Clear</p>
          </div>
          <div class="popTitle mr15 color2">CART</div>
          <img
            src="@/assets/close.png"
            alt=""
            class="closeIconTop cp"
            @click="changeFatherCartBoolean"
          />
        </div>
        <div class="scBox">
          <!-- comb商品 -->
          <div v-for="(arr, index) in combCartInfo" :key="arr.combPackageId" class="combBox">
            <div class="flex nameBox">
              <img
                :src="
                  arr.infoArr[0].isCheck
                    ? require('@/assets/checkbox-2.png')
                    : require('@/assets/checkbox-1.png')
                "
                alt=""
                class="w20 shrink mr10 cp"
                @click="cartCombSelect(index,arr)"
              />
              <div class="w100 flex flex-between bold">
                <div>{{ arr.combPackageGroupName }}</div>
                <div class="flex" style="align-items: flex-start;">
                  <div class="delBtn color1 cp" @click="changeComb(arr,0)">
                    Delete
                  </div>
                  <img
                          src="@/assets/reduce.png"
                          alt=""
                          class="deleteIcon cp"
                          @click="cartCombSelect(index,arr,'reduce')"
                          :class="arr.combPackageQuantity <= 1 ? 'disabled' : ''"
                        />
                        <div class="numbOx" style="text-align: center">
                          x{{ arr.combPackageQuantity }}
                        </div>
                        <img
                          src="@/assets/add.png"
                          alt=""
                          class="deleteIcon cp"
                        
                          @click="cartCombSelect(index,arr,'add')"
                        />
                  
                </div>
              </div>
            </div>
            <div
              v-for="(items, index) in arr.infoArr"
              :key="index + items.id"
              class="contentBox"
            >
              <div class="flex flex-between">
                <div class="w100 flex">
                  <div class="flexc2">
                    <img :src="items.pIcon" alt="" class="cakeImg shrink" />
                  </div>
                  <div class="bold mr15 flex-between flex-column ml10 w100">
                    <div class="fs12">
                      <div>
                        {{ items.productName }}
                      </div>
                      <div class="fs12">{{ items.itemname }}</div>
                    </div>

                    <div
                      class="w100 flex flex-between"
                      style="align-items: end"
                    >
                      <div>
                        <div class="fs12">
                          <p class="color1 bold mr5">
                            <span
                              v-if="
                                items.discount &&
                                items.discount.discountmothod == 0
                              "
                            >
                              RM{{
                                $roundAmount(
                                  (
                                    items.price - items.discount.discountamount
                                  ).toFixed(2)
                                )
                              }}</span
                            >
                            <span
                              v-else-if="
                                items.discount &&
                                items.discount.discountmothod == 1
                              "
                            >
                              RM{{
                                $roundAmount(
                                  (items.price *
                                    items.discount.discountamount) /
                                    100
                                ).toFixed(2)
                              }}
                            </span>
                            <span v-else
                              >RM{{ parseFloat(items.price).toFixed(2) }}</span
                            >
                          </p>
                        </div>

                        <div class="fs12 color1" v-if="items.discount">
                          {{ items.discount.special }}
                        </div>
                      </div>
                      <div class="flexc1">
                        <span class="w25px">{{ parseInt(items.quantity / arr.combPackageQuantity) }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-for="(gitems, gindex) in items.newModifiers"
                :key="gindex + gitems.groupId"
              >
                <div
                  class="flexc2 flex-between mt20 mb5 cp"
                  @click="gBoolean(index, gindex)"
                >
                  <div class="poph1 bold">{{ gitems.groupName }}</div>
                  <img
                    src="@/assets/arrow-down.png"
                    alt=""
                    class="arrowIcon"
                    :class="gitems.groupBoolean ? 'ro90' : ''"
                  />
                </div>
                <div class="line hidden-xs-only"></div>
                <transition name="fade" v-if="!gitems.groupBoolean">
                  <div>
                    <div
                      v-for="(pitems, pindex) in gitems.arr"
                      :key="pindex + pitems.id"
                    >
                      <div class="flexc2 flex-between mt10">
                        <div class="flexc2">
                          <img :src="pitems.gIcon" alt="" class="iceIcon mr5" />
                          <div>
                            <div class="fs12 mr10">{{ pitems.name }}</div>
                            <div
                              v-if="gitems.min != gitems.max"
                              class="color4 fs12"
                            >
                              RM {{ pitems.price.toFixed(2) }}
                            </div>
                          </div>
                        </div>
                        x{{ pitems.quantity }}
                      </div>
                    </div>
                  </div>
                </transition>
              </div>
            </div>
          </div>
          <!-- 非comb商品 -->
          <div
            :class="[items.combPackageId ? 'displayNone' : 'contentBox',(items.discount&&businessTime<items.discount.starttime)||(items.discount&&businessTime>items.discount.endtime)?'disItem':'']"
            v-for="(items, index) in cartInfo.items"
            :key="index + items.id"
          >
            <div class="flex flex-between">
              <div class="w100 flex">
                <div class="flexc2">
                  <img
                    :src="
                      !items.isCheck
                        ? require('@/assets/checkbox-1.png')
                        : require('@/assets/checkbox-2.png')
                    "
                    alt=""
                    class="w20 shrink mr10 cp"
                    @click="cartProductSelect(index)"
                  />
                  <img :src="items.pIcon" alt="" class="cakeImg shrink" />
                </div>
                <div class="bold mr15 flex-between flex-column ml10 w100">
                  <div class="fs12">
                    <div>
                      {{ items.productName }}
                    </div>
                    <div class="fs12">{{ items.itemname }}</div>
                  </div>

                  <div class="w100 flex flex-between" style="align-items: end">
                    <div>
                      <div class="fs12">
                        <p class="color1 bold mr5">
                          <!-- 显示单个商品总价 -->
                          <!-- <span>RM{{ parseFloat(cartPrice[index].price).toFixed(2) }}</span> -->
                          <!-- 显示单个商品单价 -->
                          <span
                            v-if="
                              items.discount &&
                              items.discount.discountmothod == 0
                            "
                          >
                            RM{{
                              $roundAmount(
                                (
                                  items.price - items.discount.discountamount
                                ).toFixed(2)
                              )
                            }}</span
                          >
                          <span
                            v-else-if="
                              items.discount &&
                              items.discount.discountmothod == 1
                            "
                          >
                            RM{{
                              $roundAmount(
                                (items.price * items.discount.discountamount) /
                                  100
                              ).toFixed(2)
                            }}
                          </span>
                          <span v-else
                            >RM{{ parseFloat(items.price).toFixed(2) }}</span
                          >
                        </p>
                      </div>

                      <div class="fs12 color1" v-if="items.discount">
                        {{ items.discount.special }}
                      </div>
                    </div>
                    <div class="flexc1">
                      <div
                        class="delBtn color1 cp"
                        @click="deleteProductIndex(index)"
                      >
                        Delete
                      </div>
                      <img
                        src="@/assets/reduce.png"
                        alt=""
                        class="deleteIcon cp"
                        :class="items.quantity <= 1 ? 'disabled' : ''"
                        @click="cartProductReduce(index)"
                      />
                      <span class="w25px">{{ items.quantity }}</span>
                      <img
                        src="@/assets/add.png"
                        alt=""
                        class="deleteIcon cp"
                        :class="items.quantity >= 99 ? 'disabled' : ''"
                        @click="cartProductAdd(index)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-for="(gitems, gindex) in items.newModifiers"
              :key="gindex + gitems.groupId"
            >
              <div
                class="flexc2 flex-between mt20 mb5 cp"
                @click="gBoolean(index, gindex)"
              >
                <div class="poph1 bold">{{ gitems.groupName }}</div>
                <img
                  src="@/assets/arrow-down.png"
                  alt=""
                  class="arrowIcon"
                  :class="gitems.groupBoolean ? 'ro90' : ''"
                />
              </div>
              <div class="line hidden-xs-only"></div>
              <transition name="fade" v-if="!gitems.groupBoolean">
                <div>
                  <div
                    v-for="(pitems, pindex) in gitems.arr"
                    :key="pindex + pitems.id"
                  >
                    <div class="flexc2 flex-between mt10">
                      <div class="flexc2">
                        <img
                          :class="items.isCheck ? '' : 'disabled'"
                          v-if="gitems.min != gitems.max"
                          :src="
                            pitems.isSelect
                              ? require('@/assets/checkbox-2.png')
                              : require('@/assets/checkbox-1.png')
                          "
                          alt=""
                          class="w20 shrink mr10 cp"
                          @click="iceBoolean(index, gindex, pindex)"
                        />
                        <img :src="pitems.gIcon" alt="" class="iceIcon mr5" />
                        <div>
                          <div class="fs12 mr10">{{ pitems.name }}</div>
                          <div
                            v-if="gitems.min != gitems.max"
                            class="color4 fs12"
                          >
                            RM {{ pitems.price.toFixed(2) }}
                          </div>
                        </div>
                      </div>
                      <div v-if="gitems.min == gitems.max" class="numbOx">
                        x{{ pitems.quantity }}
                      </div>
                      <div v-else class="flexc2">
                        <img
                          src="@/assets/reduce.png"
                          alt=""
                          class="deleteIcon cp"
                          :class="pitems.quantity <= 1 ? 'disabled' : ''"
                          @click="cartToppingChange(index, gindex, pindex, 2)"
                        />
                        <div class="numbOx" style="text-align: center">
                          {{ pitems.quantity }}
                        </div>
                        <!-- <div>{{items.quantity}} newModifiers个数：{{ gitems.quantity}},商品最大数：{{gitems.max }},除以：{{ gitems.quantity/items.quantity >= gitems.max }},newModifiers最大数：{{ gitems.max }}</div> -->
                        <img
                          src="@/assets/add.png"
                          alt=""
                          class="deleteIcon cp"
                          :class="
                            gitems.quantity >= gitems.max ? 'disabled' : ''
                          "
                          @click="cartToppingChange(index, gindex, pindex, 1)"
                        />
                        <!-- @click="++pitems.quantity" -->
                      </div>
                    </div>
                  </div>
                </div>
              </transition>
            </div>
            <!-- <div
              v-if="index < cartInfo.items.length - 1 && !items.combPackageId"
              class="contentBtmLine"
            ></div> -->
          </div>

          <div class="btmBox btmBoxMobile" style="bottom: 0">
            <div class="right pr15 totalPrice">
              TOTAL: RM
              {{
                discountPrice == 0 || discountPrice 
                  ? parseFloat(discountPrice).toFixed(2)
                  : parseFloat(Number(price)).toFixed(2)
              }}
              <!--  @@@ -->
            </div>
            <div class="flex pd15 mPd7">
              <button
                class="btn checkoutBtn payBtn mr15 continueBtn"
                @click="continueShop"
              >
                CONTINUE SHOPPING
              </button>
              <button
                class="btn checkoutBtn"
                :class="chooseArr && chooseArr.length > 0 ? '' : 'disabled'"
                @click="isLogin == 1 && userinfo ? checkOut() : openRegister()"
              >
                GO TO CHECKOUT
              </button>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>

    <div class="" v-if="!onlyUser">
      <el-drawer
        title="购物车"
        :wrapperClosable="false"
        :visible.sync="orderBoolean"
        direction="btt"
        size="100%"
        custom-class="cartDrawer"
        :with-header="false"
        :append-to-body="true"
        :modal-append-to-body="false"
      >
        <div class="cartBox bgBox cartBoxMobile">
          <div class="flexc2 flex-between cartTopBox p-re">
            <div class="flex cp" @click="setCartEmpty()">
              <p class="popTitle color2">Self pick-up</p>
            </div>
            <img
              src="@/assets/close.png"
              alt=""
              class="closeIconTop cp"
              style="padding: 10px"
              @click="
                (orderBoolean = false),
                  closeSelectDiscount(),
                  (discountSelectObj = ''),
                  (discountPrice = null),
                  (codeDiscount = 0)
              "
            />
          </div>

          <div class="scBox pickBox scBoxPdBtm">
            <!-- <el-time-select
            :append-to-body=false
  v-model="value"
  @blur="testblur"
  :picker-options="{
    start: '08:30',
    step: '00:15',
    end: '18:30'
  }"
  placeholder="选择时间">
</el-time-select> -->
            <div class="contentBox">
              <div class="bgwhite">
                <div class="flex flex-between">
                  <div>
                    <div class="poph1 bold mt5 mb10">Store Information</div>
                  </div>
                </div>
                <div class="line"></div>
                <div>
                  <div class="poph1 bold mt15">{{ storeObj.storename }}</div>
                  <div class="popspan1">
                    <p>{{ storeObj.address }}</p>
                    <p class="mt5">
                      Weekday: {{ storeObj.weekdayopen.substring(0, 5) }} -
                      {{ storeObj.weekdayclose.substring(0, 5) }}
                    </p>
                    <p>
                      Weekend: {{ storeObj.weekendopen.substring(0, 5) }} -
                      {{ storeObj.weekendclose.substring(0, 5) }}
                    </p>
                    <p>
                      Holiday: {{ storeObj.holidayopen.substring(0, 5) }} -
                      {{ storeObj.holidayclose.substring(0, 5) }}
                    </p>
                    <p>Tel: {{ storeObj.phone }}</p>
                  </div>
                </div>
              </div>
              <div class="bgwhite mt4">
                <div class="flex flex-between">
                  <div>
                    <div class="poph1 bold mt5 mb10">Email</div>
                  </div>
                </div>
                <div class="line"></div>
                <div class="mt10 mb10 flexc2">
                  <el-input
                    disabled
                    v-model="userinfo.email"
                    placeholder="Please enter your email to receive order details"
                  ></el-input>
                  <span class="edit cp color2" @click="editBoolean = true"
                    >edit</span
                  >
                </div>
              </div>

              <div class="p-re pb300">
                <div class="bgwhite mt4">
                  <div class="poph1 bold mb10">Pickup date/time</div>
                  <div class="line"></div>

                  <div class="flexcc mt10 mb10">
                    <div class="block w50">
                      <el-date-picker
                        :append-to-body="false"
                        style="width: 100% !important"
                        v-model="timeObj.date"
                        type="date"
                        :editable="false"
                        :picker-options="pickerOptions()"
                        value-format="yyyy-MM-dd"
                        placeholder="YY-MM-DD "
                        popper-class="timeAbs"
                      >
                      </el-date-picker>
                    </div>

                    <div class="block w50">
                      <el-time-select
                        :append-to-body="false"
                        popper-class="timeAbs"
                        :class="timeObj.date ? '' : 'disabled'"
                        v-model="timeObj.time"
                        :editable="false"
                        :disabled="selectTime.overToday"
                        :picker-options="{
                          start: selectTime.start,
                          step: '00:15',
                          end:
                            selectTime.end == '00:00'
                              ? '23:59'
                              : selectTime.end,
                        }"
                        :placeholder="
                          selectTime.overToday ? 'Closed today' : '00:00'
                        "
                      >
                      </el-time-select>
                    </div>
                  </div>
                </div>
                <div class="bgwhite mt4">
                  <div class="poph1 bold mb10">Order details</div>
                  <div class="line"></div>
                  <div
                    v-for="(items, index) in checkOutArr"
                    :key="index + items.id"
                  >
                    <div class="flex mt10" :class="index == 0 ? '' : 'mt30'">
                      <img :src="items.pIcon" alt="" class="pIcon" />
                      <div class="w100 conFlex ml10">
                        <div class="poph1 bold">
                          {{ items.itemname }}
                        </div>
                        <div class="flex-between flex">
                          <div
                            v-if="items.discount"
                            class="flexcc mt10 h20 mmt5 mmb5 flex-column"
                          >
                            <!-- 显示单个商品总价 -->
                            <p
                              class="pDesc"
                              style="text-decoration: line-through"
                            >
                              RM{{
                                cartPrice[
                                  items.cartIndex
                                ].originalPrice.toFixed(2)
                              }}
                            </p>
                            <p class="color1 bold mr5">
                              <span>
                                RM{{
                                  cartPrice[items.cartIndex].price.toFixed(2)
                                }}</span
                              >
                            </p>
                            <!-- 显示单个商品单价 -->
                            <!-- <p class="pDesc" style="text-decoration:line-through;">RM{{ items.price.toFixed(2) }}</p>    
                            <p class="color1 bold mr5" >                  
                              <span v-if="items.discount.discountmothod==0"> RM{{ ((items.price-items.discount.discountamount).toFixed(2)) }}</span>
                              <span v-else-if="items.discount.discountmothod==1">
                                RM{{ $roundAmount(items.price*items.discount.discountamount/100).toFixed(2) }}
                                </span>
                            </p> -->
                          </div>
                          <!-- 显示单个商品总价 -->
                          <p v-else class="bold mt25 h20">
                            RM{{ cartPrice[items.cartIndex].price.toFixed(2) }}
                          </p>
                          <!-- 显示单个商品单价 -->
                          <!-- <p v-else class=" bold mt25  h20 ">RM{{ items.price.toFixed(2) }}</p> -->

                          <!-- <div class="poph1 bold">
                            RM {{ items.price.toFixed(2) }}
                          </div> -->
                          <div style="display: flex; align-items: end">
                            x{{ items.quantity }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-for="(gitems, gindex) in items.newModifiers"
                      :key="gindex + gitems.groupId"
                    >
                      <div class="flexc2 flex-between mt10 mb5">
                        <div class="poph1 bold">{{ gitems.groupName }}</div>
                        <img
                          src="@/assets/arrow-down.png"
                          alt=""
                          class="arrowIcon"
                          :class="gitems.groupBoolean ? 'ro90' : ''"
                        />
                      </div>
                      <div class="line"></div>
                      <div
                        v-for="(pitems, pindex) in gitems.arr"
                        :key="pindex + pitems.id"
                      >
                        <transition name="fade" v-if="!gitems.groupBoolean">
                          <div class="flexc2 flex-between mt10">
                            <div class="flexc2">
                              <img
                                :src="pitems.gIcon"
                                alt=""
                                class="iceIcon mr5"
                              />
                              <span class="">{{ pitems.name }}</span>
                            </div>
                            <div class="">x{{ pitems.quantity }}</div>
                          </div>
                        </transition>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="bgwhite mt4">
                  <!-- <div class="flex-between mt10"><div>Packaging fee</div><div>-</div></div> -->

                  <el-popover
                    placement="bottom"
                    popper-class="couponPopover"
                    v-model="visible"
                    trigger="manual"
                  >
                    <div>
                      <div class="center bolder mb20 p-re">
                        Please select discount
                        <img
                          src="@/assets/close.png"
                          class="closeIconTop disClose cp"
                          @click.stop="visible = false"
                          alt=""
                        />
                      </div>
                      <div
                        v-for="(item, index) in discountList"
                        v-if="item.canUse"
                        class="disBox mb10 cp"
                        :key="item.id"
                        @click="
                          selectDiscount(index),
                            (visible = false),
                            (codeDiscount = ''),
                            (discountCode = '')
                        "
                      >
                        <div class="color1 mr10">{{ item.campaignname }}</div>
                        <img
                          :src="
                            item.select
                              ? require('@/assets/checkbox-2.png')
                              : require('@/assets/checkbox-1.png')
                          "
                          alt=""
                          class="w20Icon"
                        />
                      </div>
                    </div>

                    <el-button
                      class="popdiscountBtn"
                      slot="reference"
                      :disabled="!discountList || discountList.length <= 0"
                    >
                      <div
                        class="w100 flex-between mt10"
                        @click="
                          discountList &&
                          discountList.length > 0 &&
                          (orderDisCan==0||orderDisCan==1&&discountListCan) &&
                          canUseDiscount
                            ? (visible = !visible)
                            : ''
                        "
                      >
                        <div>Discount</div>
                        <div
                          v-if="
                            discountList &&
                            discountList.length > 0 &&
                            (orderDisCan==0||orderDisCan==1&&discountListCan) &&
                            canUseDiscount
                          "
                        >
                          <div>
                            <div v-if="discountSelectObj" class="flex flexc2">
                              <span class="color0">{{
                                discountSelectObj.campaignname
                              }}</span
                              ><img
                                src="@/assets/clean.png"
                                class="cleanIcon cp pd5"
                                alt=""
                                @click.stop="
                                  closeSelectDiscount(),
                                    (discountSelectObj = ''),
                                    (discountPrice = null),
                                    (timeObj = { date: '', time: '' })
                                "
                              />
                            </div>
                            <span v-else>></span>
                          </div>
                        </div>
                        <div v-else>-</div>
                      </div>
                    </el-button>
                  </el-popover>

                  <!-- <div class="flex-between mt10"><div>Coupon /Voucher</div><div>-</div></div> -->
                  <div>
                    <div class="flex-between mt10 flexc2">
                      <div>Discount code (Optional)</div>
                      <div v-if="!codeDiscount">
                        <input
                          type="text"
                          @blur="getDis"
                          :disabled="disCodePop"
                          v-model="discountCode"
                          class="codeInput"
                        />
                        <el-popover
                          width="100%"
                          trigger="manual"
                          content="Error code!"
                          v-model="disCodePop"
                        >
                        </el-popover>
                      </div>
                      <div class="color0 fs12 flexc2" v-else>
                        {{ codeDiscount.special }}
                        <img
                          src="@/assets/clean.png"
                          class="cleanIcon cp pd5"
                          alt=""
                          @click="
                            (codeDiscount = ''),
                              (discountCode = ''),
                              (timeObj = { date: '', time: '' }),
                              (discountPrice = null)
                          "
                        />
                      </div>
                    </div>
                    <div
                      v-if="discountPrice==0 || discountPrice "
                      class="flex-between mt10"
                    >
                      <div>Discount amount:</div>
                      <div class="color1">
                        RM -{{ (price - discountPrice).toFixed(2) }}
                      </div>
                    </div>
                    <div class="mt10">
                      Add a note for the store(optional)
                      <textarea
                        class="markBox"
                        maxlength="100"
                        cols="10"
                        rows="3"
                        v-model="areaMark"
                      ></textarea>
                    </div>
                  </div>

                  <!-- <div class="flex-between mt10 mb10"><div>Member points</div><div>-</div></div> -->
                </div>
              </div>
            </div>
          </div>

          <div class="btmBox btmBoxMobile">
            <div
              class="p-re pd15 detailPriceBox"
              :class="priceDetailBoolean ? 'detailPriceBoxOpen' : ''"
            >
              <img
                src="@/assets/close.png"
                alt=""
                class="cp detailClose"
                @click="priceDetailBoolean = false"
              />
              <div class="center bold color2 fs16">Details</div>
              <div class="color4 mt5 fs12 center">
                Please refer to the following single page for the specific
                discount amount
              </div>
              <div class="mt15">
                <div class="flex-between">
                  <span>SUBTOTAL:</span
                  ><span
                    >RM
                    {{
                      discountPrice == 0 ||
                      discountPrice 
                        ? parseFloat(discountPrice - tax).toFixed(2)
                        : parseFloat(Number(price) - tax).toFixed(2)
                    }}</span
                  >
                </div>
                <!-- <div class="flex-between "><span>SUBTOTAL:</span><span>RM {{ (originalPrice-tax).toFixed(2) }}</span></div> -->

                <!-- <div class="flex-between mt5" v-if="discountSelectObj"><span>{{ discountList[0].campaignname }}:</span><span>RM -{{ (price - discountPrice).toFixed(2) }}</span></div>
                <div class="flex-between mt5" v-if="codeDiscount&&discountPrice"><span>{{ codeDiscount.campaignname }}:</span><span>RM -{{ (price - discountPrice).toFixed(2) }}</span></div> -->
                <div class="flex-between mt5">
                  <span>SST@6%:</span><span>RM {{ tax }}</span>
                </div>

                <!-- <div class="flex-between mt5" v-if="codeDiscount"><span>Code Discount:</span><span>RM {{ (price - discountPrice).toFixed(2) }}</span></div> -->
                <div class="flex-between mt5">
                  <span>TOTAL:</span>RM
                  {{
                    (discountPrice == 0 ||
                      discountPrice ) ||
                    codeDiscount
                      ? parseFloat(discountPrice).toFixed(2)
                      : parseFloat(Number(price)).toFixed(2)
                  }}
                </div>
                <!--  @@@ -->
                <div class="btmDetailBoxLine mt15"></div>
              </div>
            </div>
            <div class="right pr15 totalPrice flex flex-end">
              <div
                class="mr15 detailBtn flexc2 cp"
                @click="priceDetailBoolean = true"
              >
                <span class="color1 mr5" @click="detailPriceBoxOpen = true"
                  >Details
                </span>
                <img
                  :src="
                    priceDetailBoolean
                      ? require('@/assets/arrow-up-pink.png')
                      : require('@/assets/arrow-right-pink.png')
                  "
                  alt=""
                />
              </div>
              TOTAL:
              <span class="bold"
                >RM
                {{
                      discountPrice == 0 ||
                  discountPrice
                    ? parseFloat(discountPrice).toFixed(2)
                    : parseFloat(Number(price)).toFixed(2)
                }}</span
              >
              <!--  @@@ -->
            </div>
            <div class="flex pd15 mPd7">
              <button
                class="btn checkoutBtn payBtn mr15"
                :class="checkOutArr && checkOutArr.length > 0 ? '' : 'disabled'"
                @click="continueShop"
              >
                CONTINUE SHOPPING
              </button>
              <div class="p-re">
                <button
                  class="btn checkoutBtn payBtn"
                  :class="
                    checkOutArr && checkOutArr.length > 0 ? '' : 'disabled'
                  "
                  @click="submit"
                >
                  PAY NOW
                </button>

                <div class="overBtn">
                  <!-- 正式 -->
                  <!-- <form id="form" name="frmPayment" method="post" action="https://securepay.e-ghl.com/IPG/Payment.aspx"> -->
                  <!-- 测试 -->
                  <form
                    id="form"
                    name="frmPayment"
                    method="post"
                    :action="payreUrl"
                  >
                    <!-- <form id="form" name="frmPayment" method="post" action="https://pay.e-ghl.com/IPGSG/Payment.aspx"> -->
                    <input type="hidden" name="TransactionType" value="SALE" />
                    <input
                      type="hidden"
                      name="Amount"
                      v-if="
                      discountPrice == 0 ||
                        discountPrice 
                      "
                      :value="parseFloat(discountPrice).toFixed(2)"
                    />
                    <input
                      type="hidden"
                      name="Amount"
                      v-else
                      :value="parseFloat(Number(price)).toFixed(2)"
                    />
                    <!-- @@@ -->
                    <!-- <input type="hidden" name="Amount" v-model="((discountPrice && discountPrice != 0 && discountPrice != "0.00")? discountPrice : price.toFixed(2))"> -->
                    <input type="hidden" name="CurrencyCode" value="MYR" />
                    <input type="hidden" name="PaymentId" :value="orderid" />
                    <input type="hidden" name="OrderNumber" :value="orderid" />
                    <input
                      type="hidden"
                      name="PaymentDesc"
                      :value="
                        checkOutArr && checkOutArr.length > 0
                          ? checkOutArr[0].itemname
                            ? checkOutArr[0].itemname
                            : 'Payment'
                          : ''
                      "
                    />
                    <input type="hidden" name="PymtMethod" value="ANY" />
                    <!-- <input type="hidden" name="PaymentGateway" value="false"> -->
                    <input
                      type="hidden"
                      name="CustName"
                      :value="userinfo.nickname + ' ' + userinfo.surname"
                    />
                    <input
                      type="hidden"
                      name="CustEmail"
                      :value="userinfo.email"
                    />
                    <input
                      type="hidden"
                      name="CustPhone"
                      :value="userinfo.mobile"
                    />
                    <!-- <input type="hidden" name="MerchantReturnURL" value="https://mercha.merchdomain.com/pymtresp.aspx"> -->
                    <input
                      type="hidden"
                      name="MerchantReturnURL"
                      v-model="MerchantReturnURL"
                    />
                    <input
                      type="hidden"
                      name="MerchantCallBackURL"
                      v-model="MerchantCallBackURL"
                    />
                    <input type="hidden" name="ServiceId" value="GCO" />
                    <input type="hidden" name="LanguageCode" value="EN" />
                    <input type="hidden" name="PageTimeout" value="600" />
                    <input type="hidden" name="HashValue" v-model="hashCode" />
                    <input type="submit" value="提交" />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script scoped>
// let testVm=""
//   window.onbeforeunload = () =>{
//     testVm.$loading().close()
//   }
import { mapMutations} from 'vuex'
import { debug, log } from "console";
import axios from "axios";
import Calendar from "vue-calendar-component";
import tracking from "../../plugins/track.js";
// import { eventBus } from "@/main.js";
export default {
  components: {
    Calendar,
  },
  name: "Cart",
  props: {
    menu: { type: Array },
    onlyUser: Boolean,
    addCartBoolean: { type: Boolean },
    loginStatus: Number,
    cartInfoProps: {},
    businessTime:String
  },
  computed: {
    
    tax() {
      return parseFloat(
        this.discountPrice===0?0:
        (this.discountPrice
          ? (this.discountPrice * 6) / 106
          : (this.price * 6) / 106)
      ).toFixed(2);
    },
    combCartInfo() {
      let obj = [],
        cartInfo = this.cartInfo;
      if (cartInfo && cartInfo.items && cartInfo.items.length > 0) {
        for (let i = 0; i < cartInfo.items.length; i++) {
          let isCombHave = false;
          if (cartInfo.items[i].combPackageGroupName) {
            let sameKey = false;
            for (let k = 0; k < obj.length; k++) {
              if (
                obj[k].combPackageGroupKey ==
                cartInfo.items[i].combPackageGroupKey
              ) {
                obj[k].infoArr.push(cartInfo.items[i]);
                sameKey = true;
                break;
              }
            }
            if (!sameKey) {
              obj.push({
                combPackageGroupName: cartInfo.items[i].combPackageGroupName,
                combPackageGroupKey: cartInfo.items[i].combPackageGroupKey,
                combPackageId: cartInfo.items[i].combPackageId,
                combPackageQuantity:cartInfo.items[i].combPackageQuantity,
                infoArr: [cartInfo.items[i]],
              });
            }
          }
        }
      }
      obj = this.mergeInfoArr(obj);
      // console.log(obj);
      return obj;
    },
    
    cartNumber() {
      let num = 0;
      let cartInfo = this.cartInfo;
     
      if(this.combCartInfo){
        num=this.combCartInfo.reduce(function (prev, cur, index, arr) {
          return prev + cur.combPackageQuantity;
        },0);
      }
      if (cartInfo && cartInfo.items && cartInfo.items.length > 0) {
        for (let i = 0; i < cartInfo.items.length; i++) {
          if(!cartInfo.items[i].combPackageId)num += cartInfo.items[i].quantity;
        }
      }
      // console.log(num);
      return num;
    },
    canUseDiscount() {
      let checkOutArr = this.checkOutArr;
      let flag = true;
      for (let i = 0; i < checkOutArr.length; i++) {
        if (
          checkOutArr[0].discount &&
          checkOutArr[0].discount.multiredeem == 0
        ) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    canSelectDateAndTime(){
      let arr=[];
      if(this.codeDiscount&&this.codeDiscount.pickupstartdate){
        let o={
          start:new Date(this.codeDiscount.pickupstartdate).getTime(),
          end:new Date(this.codeDiscount.pickupenddate).getTime()
        }
        arr.push(o)
      }
      if(this.discountSelectObj){
        let o={
          start:new Date(this.discountSelectObj.pickupstartdate).getTime(),
          end:new Date(this.discountSelectObj.pickupenddate).getTime()
        }
        arr.push(o)
      }
      this.checkOutArr.forEach(ele=>{
        if(ele.discount){
          let o={
            start:new Date(ele.discount.pickupstartdate).getTime(),
            end:new Date(ele.discount.pickupenddate).getTime()
          }
          arr.push(o)
        }
      })

      return this.calculateIntersection(arr);
    },
    orderDisCan(){
      //2不能同时使用优惠券  1能同时使用优惠券  0不含discount商品，优惠券不用检测multiredeem
      let flag=1,checkOutArr=this.checkOutArr,hasDiscount=false;
      for (let k = 0; k < checkOutArr.length; k++) {
        if(checkOutArr[k].discount){
          hasDiscount=true;
          if(checkOutArr[k].discount.multiredeem!=1){
            flag=2;
            break;
          }
          
        }
      }
      return hasDiscount?flag:0;
    }
  },
  data() {
    return {
      test: { 12: [{ a: 1, b: 2 }] },
      areaMark: "",
      priceDetailBoolean: true,
      changeStorePopup: false,
      MerchantReturnURL: "",
      MerchantCallBackURL: "",
      hashCode: "",
      orderid: "",
      chooseArr: [],
      checkOutArr: [],
      cartBoolean: this.addCartBoolean,
      logBoolean: true,
      isLogin: this.loginStatus || (this.getStorage() ? 1 : 0),
      person: {
        name: "",
        phone: "",
        address: "",
      },
      cartInfo: {},
      timeObj: {
        date: "",
        time: "",
      },
      serveTime: {},
      selectTime: {
        overToday: false,
      },
      price: 0,
      campaigndiscountPrice: 0,
      originalPrice: 0,
      discountPrice: null,
      storeObj: {},
      storeTime: {},
      orderBoolean: false,
      userPtsObj: "",
      discountList: "",
      discountCode: "",
      disCodePop: false,
      codeDiscount: "",
      discountSelectObj: "",
      visible: false,
      userinfo: "",
      openat: "",
      editBoolean: false,
      pointUpPopup: false,
      discountListCan:false,
      cartPrice: [],
      globalDataUrl: "",
      payPassword: process.env.VUE_APP_PAYPSD,
      payreUrl: process.env.VUE_APP_PAYURL,
    };
  },

  methods: {
    ...mapMutations([
      "CLEAR_SELECT",
    ]),
    changeComb(arr,number){
      let items=this.cartInfo.items;
      for(let i=0;i<items.length;i++){
        let ele=items[i];
        if(ele.combPackageGroupKey&&arr.combPackageGroupKey.indexOf(ele.combPackageGroupKey)!=-1){
          if(number==0){
            items.splice(i,1);
            i--;
            // console.log("items",items,i)
          }else{
            ele.combPackageQuantity=number||1;
          }
        }
      }
      // console.log(`output->items`,items)
      this.cartInfo.items=items;
      this.$forceUpdate();
      
    },
    mergeInfoArr(combCartInfo) {
      for (var i = 0; i < combCartInfo.length - 1; i++) {
        var currentComb = combCartInfo[i];
        var currentInfoArr = currentComb.infoArr;

        for (var j = i + 1; j < combCartInfo.length; j++) {
          var nextComb = combCartInfo[j];
          var nextInfoArr = nextComb.infoArr;

          if (
            currentComb.combPackageId == nextComb.combPackageId &&
            this.isInfoArrEqual(currentInfoArr, nextInfoArr)
          ) {
            currentComb.combPackageGroupKey+=","+nextComb.combPackageGroupKey;
            currentComb.combPackageQuantity++;
            combCartInfo.splice(j, 1);
            j--;
          }
        }

        currentComb.infoArr = currentInfoArr;
      }

      return combCartInfo;
    },

    isInfoArrEqual(infoArr1, infoArr2) {
      if (infoArr1.length !== infoArr2.length) {
        return false;
      }

      for (var i = 0; i < infoArr1.length; i++) {
        var info1 = infoArr1[i];
        var info2 = infoArr2[i];

        if (!this.isInfoEqual(info1, info2)) {
          return false;
        }
      }

      return true;
    },

    isInfoEqual(info1, info2) {
      // 根据需要自定义判断两个info对象是否相同的逻辑
      // 这里假设当id相同时，认为两个info对象相同
      return (
        JSON.stringify(info1.modifiers) === JSON.stringify(info2.modifiers) &&
        info1.id === info2.id
      );
    },
    calculateIntersection(timeArr) {
      let result = timeArr[0]; // 将第一个时间段作为初始交集

      for (let i = 1; i < timeArr.length; i++) {
        const currentTime = timeArr[i];

        // 检查当前时间段与交集的重叠部分
        const intersectionStart = Math.max(result.start, currentTime.start);
        const intersectionEnd = Math.min(result.end, currentTime.end);

        // 如果重叠部分存在，则更新交集
        if (intersectionStart <= intersectionEnd) {
          result.start = intersectionStart;
          result.end = intersectionEnd;
        } else {
          // 如果重叠部分不存在，则交集为空，直接返回
          return null;
        }
      }

      return result;
    },
    openRegister() {
      this.isLogin = 2;
      this.braze.logCustomEvent("Guest Log in", {
        Timestamp: new Date(),
      });
    },
    getStoreTime() {
      let that = this;
      // this.$loading();
      return new Promise((resolve, reject) => {
        this.$http
          .Get(
            "mobile/storeorderstatus?orderstoreid=" +
              this.storeObj.orderstoreid,
            {}
          )
          .then(function (res) {
            if (res.code == 1 && res.openat) {
              // res.openat="2023-08-22T02:54:07.904Z";
              that.initServeTime(res.openat);

              let g = new Date(res.openat).getTime();
              // that.openat=g;

              if (g < that.serveTime.haomiaoNow) {
                //开门时间早于现在时间：营业中
                that.serveTime.openatHaomiao = that.serveTime.haomiaoNow;
              } else {
                //开门时间晚于现在时间：待营业
                that.serveTime.openatHaomiao = g;
              }
              resolve(res);
            } else {
              that.serveTime.openatHaomiao = that.serveTime.haomiaoNow;
              reject(res);
            }
            // that.$loading().close();
          })
          .catch(function (err) {
            that.serveTime.openatHaomiao = that.serveTime.haomiaoNow;
            // that.$loading().close();
            reject(err);
          });
      });
    },

    changeFatherCartBoolean() {
      this.cartBoolean = false;
      this.discountCode = "";
      this.$emit("changeFatherCartBoolean", false);
    },
    changeStore() {
      this.changeStorePopup = true;
      // this.$msgbox.confirm('If you change store, your cart will be cleared.',"Tips",  {
      //     confirmButtonText: 'Confirm',
      //     cancelButtonText: 'Cancel',
      //     // type: 'info'
      //   }).then(() => {
      //     this.$router.push('/chooseLocation/index')

      //   }).catch(() => {

      //   });
    },
    goHome(){
      this.CLEAR_SELECT();
      this.$router.push('/chooseLocation/index')
    },
    linkToOrders() {
      try {
        this.storeObj = JSON.parse(localStorage.getItem("storeObj"));
      } catch (e) {}
      // if(!this.storeObj){
      //   alert("Please select a store first!")
      //   this.$router.push({
      //     name: 'chooseLocation',
      //   }, () => {})
      //   return;
      // }else{
      this.$router.push("/center/orderList");
      // }
    },
    continueShop() {
      this.orderBoolean = false;
      this.closeSelectDiscount(), (this.discountSelectObj = "");
      this.discountPrice = null;
      this.codeDiscount = "";
      let urlw = window.location.href;
      if (
        urlw.indexOf("/order") == -1 ||
        urlw.indexOf("/order/orderDetail") != -1
      ) {
        this.$router.push({
          name: "order",
          path: "/order",
        });
      } else {
        this.cartBoolean = false;
        this.discountCode = "";
      }
    },
    changeLoginStatus(data) {
      // console.log(data);
      this.isLogin = data;
      this.$emit("changeLoginStatus", data);
    },
    getuserinfo(data) {
      this.userinfo = data;
      this.userPts();
    },
    editBooleanReceived(data) {
      // console.log(data);
      this.editBoolean = data;
    },
    getStorage() {
      let u = localStorage.getItem("UserId"),
        a = localStorage.getItem("AccessToken");
      if (u && a) {
        return true;
      } else {
        return false;
      }
    },
    checkLogin() {
      let flag = this.getStorage();
      if (flag) {
        this.isLogin = 1;
        this.getuserinfoFn();
      } else {
        this.isLogin = 2;
      }
      return this.isLogin;
    },

    userPts() {
      let that = this;
      return new Promise((resolve, reject) => {
        this.$http.Get("mobile/user/pts", {}).then((res) => {
          // console.log(res);
          if (res.code == 1) {
            let ptsObj = JSON.parse(localStorage.getItem("pts"));
            // console.log(ptsObj);
            //
            // console.log(that.userPtsObj.level,res.level)
            if (
              ptsObj &&
              ptsObj.level &&
              res.level &&
              ptsObj.level < res.level
            ) {
              that.pointUpPopup = true;
            }
            localStorage.setItem("pts", JSON.stringify(res));
            that.userPtsObj = res;
            tracking.setCustomAtt(that, "tier_level", res.levelname);
            tracking.setCustomAtt(that, "tier_points", res.pts);
          }
          resolve();
        });
      });
    },
    iceBoolean(index, gindex, pindex) {
      this.cartInfo.items[index].newModifiers[gindex].arr[pindex].isSelect =
        !this.cartInfo.items[index].newModifiers[gindex].arr[pindex].isSelect;
      // console.log(11);
      this.cartInfo = Object.assign({}, this.cartInfo);
      // this.$forceUpdate();
    },
    cartProductSelect(index, pitem) {
      // console.log(pitem);
      let boolean = !this.cartInfo.items[index].isCheck;
      this.cartInfo.items[index].isCheck = boolean;
      this.cartInfo.items[index].newModifiers.forEach((ele) => {
        ele.arr.forEach((ele2) => {
          ele2.isSelect = boolean;
        });
      });

      this.$forceUpdate();
    },
    cartCombSelect(index, arr,type) {
      let boolean = !arr.infoArr[0].isCheck;
      arr.infoArr.forEach(element => {
        const matchingItem = this.cartInfo.items.find(item =>{
          if(item.id === element.id&&item.combPackageGroupKey===element.combPackageGroupKey){
            return item;
          }
        });
        if (matchingItem) {
          let num=matchingItem.quantity/arr.combPackageQuantity;//单位数量
          let numComb=matchingItem.combPackageQuantity/arr.combPackageQuantity;//单位数量
          // console.log(`output->num`,num)
          // console.log(`output->`,matchingItem.quantity)
          if(type=="add"){
            let n=matchingItem.quantity+num;
            let nc=matchingItem.combPackageQuantity+numComb
            // console.log(`output->n`,n)
            this.$set(matchingItem, 'quantity', n);
            this.$set(matchingItem, 'combPackageQuantity',nc);
            // matchingItem.quantity=matchingItem.quantity+num
          }else if(type=="reduce"){
            matchingItem.quantity-=num
            matchingItem.combPackageQuantity-=numComb
            this.$set(matchingItem, 'quantity',  matchingItem.quantity<=0?num:matchingItem.quantity);
            this.$set(matchingItem, 'quantity',  matchingItem.combPackageQuantity<=0?numComb:matchingItem.combPackageQuantity);
          }else{
            this.$set(matchingItem, 'isCheck', boolean);
          }
        }
      });
      
      if(type=="add"){      
          arr.combPackageQuantity++
        }else if(type=="reduce"){
          arr.combPackageQuantity<=1?1:arr.combPackageQuantity--
        }
      this.$forceUpdate();
    },
    cartProductReduce(index) {
      let n = this.cartInfo.items[index].quantity;
      --this.cartInfo.items[index].quantity;

      // this.cartInfo.items[index].newModifiers.forEach((newEle) => {
      //   newEle.quantity-=parseInt(newEle.quantity/n);
      //   newEle.arr.forEach((nextArr) => {
      //     let arrn=Math.ceil(nextArr.quantity/n);
      //     nextArr.quantity -=  arrn<1?1:arrn;
      //     if(nextArr.quantity<=0)nextArr.quantity=1;
      //   });
      // });
      // this.cartInfo.items[index].modifiers.forEach((ele) => {
      //   ele.quantity -= parseInt(ele.quantity / n);
      // });
      this.$forceUpdate();
      this.setCartEmpty(this.cartInfo)
    },

    deleteProductIndex(index) {
      let that = this;
      this.cartInfo.items.splice(index, 1);
      this.setCartEmpty(this.cartInfo).then(
        (res) => {
          that.$forceUpdate();
        },
        (err) => {
          // console.log(err);
        }
      );
    },

    async cartToppingChange(index, gindex, pindex, type) {
      // console.log(index, gindex, pindex, type);
      let newModifiers = this.cartInfo.items[index].newModifiers[gindex];
      let quantity = this.cartInfo.items[index].quantity;
      // type 1加  2减
      if (type == 1) {
        if (newModifiers.arr[pindex].realTime == 1) {
          this.$loading();
          let result = await this.inventory(
            this.cartInfo.items[index].newModifiers[gindex].arr[pindex].id
          );
          if (result.code == 1 && result.inventory && result.inventory > 0) {
            if (result.inventory < quantity * newModifiers.quantity) {
              alert(
                "Oops! You cannot order more due to insufficient stock. Try other awesome flavors instead."
              );
              return;
            }
          }
          this.$loading().close();
        }

        if (newModifiers.quantity >= newModifiers.max) return;

        newModifiers.arr[pindex].quantity++;
        newModifiers.quantity++;
      } else {
        newModifiers.arr[pindex].quantity--;
        newModifiers.quantity--;
        if (newModifiers.quantity < 1) return;
      }

      let groupId = newModifiers.groupId;
      let id = newModifiers.arr[pindex].id;

      this.cartInfo.items[index].modifiers.forEach((ele) => {
        if (ele.groupId == groupId && ele.id == id) {
          type == 1 ? ele.quantity++ : ele.quantity--;
        }
      });
    },
    async cartProductAdd(index) {
      let checkIdArr = [];
      this.cartInfo.items[index].newModifiers.forEach((newEle) => {
        newEle.arr.forEach((nextArr) => {
          if (nextArr.realTime == 1) {
            checkIdArr.push({ id: nextArr.id, quantity: nextArr.quantity });
          }
        });
      });

      if (checkIdArr.length > 0) {
        this.$loading();
        for (let val of checkIdArr) {
          let result = await this.inventory(val.id);
          if (result.code == 1 && result.inventory && result.inventory > 0) {
            if (
              result.inventory <
              (this.cartInfo.items[index].quantity + 1) * val.quantity
            ) {
              alert(
                "Oops! You cannot order more due to insufficient stock. Try other awesome flavors instead."
              );
              this.$loading().close();
              return false;
            }
          }
        }
        this.$loading().close();
      }

      ++this.cartInfo.items[index].quantity;

      this.$forceUpdate();
      this.setCartEmpty(this.cartInfo)
    },

    gBoolean(index1, index2) {
      // console.log(index1, index2);
      this.cartInfo.items[index1].newModifiers[index2].groupBoolean =
        !this.cartInfo.items[index1].newModifiers[index2].groupBoolean;
      this.$forceUpdate();
    },

    pickTimeFn(isToday) {
      let storeTime = this.storeTime;

      let closeTime = {
        h: storeTime.endHour,
        m: storeTime.endMin,
      };
      let openTime = {
        h: storeTime.startHour,
        m: storeTime.startMin,
      };
      if (isToday) {
        if (this.serveTime.h < openTime.h) {
          //早于开门时间
          this.selectTime = {
            start: openTime.h + ":" + openTime.m,
            end: closeTime.h + ":" + closeTime.m,
          };
        } else if (
          this.serveTime.h > closeTime.h ||
          (this.serveTime.h == closeTime.h && this.serveTime.mins > closeTime.m)
        ) {
          //晚于关门时间
          this.selectTime.overToday = true;
        } else {
          //营业中时间

          this.selectTime.start =
            (Math.floor(this.serveTime.mins / 15) + 1) * 15 >= 60
              ? ++this.serveTime.h + ":00"
              : this.serveTime.h +
                ":" +
                (Math.floor(this.serveTime.mins / 15) + 1) * 15;

          this.selectTime.end = closeTime.h + ":" + closeTime.m;
        }
      } else {
        this.selectTime = {
          start: openTime.h + ":" + openTime.m,
          end: closeTime.h + ":" + closeTime.m,
        };
      }
    },

    gotTime() {
      let that = this;
      this.$http.Get("utils/time", {}).then((res) => {
        that.initServeTime(res.time);
        // that.$emit("timeFn",{currentTime:res.time,todayBusiness:that.isWeekendTime(res.time)})
      });
    },
    initServeTime(time) {
      //1800000是30分钟的毫秒数
      // console.log(this.$DateFormat(time))
      let delayTime = 1800000;
      let s = new Date(new Date(time).getTime() + delayTime);

      // console.log(s);
      let y = s.getFullYear();
      let mon = Number(s.getMonth()) + 1;
      let d = s.getDate();
      let h = s.getHours();
      let m = s.getMinutes();
      // serveTime 第一版使用servetime记录服务器时间，用来判断当天开门时间的状态。后续加入了开门营业时间，开门营业时间需要导入后初始化，用来判断当天的开门时间的状态
      this.serveTime = {
        haomiaoNow: new Date(time).getTime(), //当前时间毫秒
        haomiao: s.getTime(), //半小时后（可取货）的毫秒
        ymd: y + "/" + mon + "/" + d,
        time: y + "/" + mon + "/" + d + " " + h + ":" + m,
        h: h,
        mins: m,
        // day:day
      };
    },
    isWeekendTime(val) {
      let isWeekend = new Date(val).getDay() < 5 ? true : false;
      let storeObj = this.storeObj,
        timeOpen,
        timeEnd;
      if (isWeekend) {
        timeOpen = storeObj.weekendopen;
        timeEnd = storeObj.weekendclose;
      } else {
        timeOpen = storeObj.weekdayopen;
        timeEnd = storeObj.weekdayclose;
      }
      return { timeOpen, timeEnd };
    },
    initOpenTime(val) {
      let tt = this.isWeekendTime(val);
      let s, e, sh, sm, eh, em;
      sh = tt.timeOpen.substring(0, 2);
      sm = tt.timeOpen.substring(3, 5);
      eh = tt.timeEnd.substring(0, 2);
      em = tt.timeEnd.substring(3, 5);
      s = sh + ":" + sm;
      e = eh + ":" + em;

      this.storeTime = {
        start: s,
        end: e,
        startHour: sh,
        startMin: sm,
        endHour: eh,
        endMin: em,
      };
    },
    checkToday(serveTime, pickTime) {
      // console.log(serveTime)
      // console.log(pickTime)
      let todayDate = new Date(serveTime).setHours(0, 0, 0, 0);
      let paramsDate = new Date(pickTime).setHours(0, 0, 0, 0); //time格式'2020/12/01'
      let isToday = todayDate === paramsDate; //时间戳相同时 True 就为今天
      return isToday;
    },

    getCart() {
      return new Promise((resolve, reject) => {
        this.$http.Get("mobile/cart", {}).then(
          (res) => {
            // console.log(res)
            if (res.code == 1) {
              let newData = [];
              if (res.data && res.data.items && res.data.items.length > 0) {
                newData = this.checkCart(this.menu, res.data);
                let items = newData.items;
                this.addNewarrData(items, newData);
              }

              this.cartInfo = newData;
              this.$forceUpdate();
              this.$emit("cartInfoFn", newData);
              resolve(res);
            } else {
              // reject(res)
            }
          },
          (err) => {
            // console.log(err);
            reject(err);
            alert(err.msg);
          }
        );
      });
    },
    checkCart(menu, cartInfo) {
      // this.$loading()
      if (!cartInfo || !cartInfo.items || cartInfo.items.length == 0) return;
      for (let i = 0; i < cartInfo.items.length; i++) {
        for (let j = 0; j < menu.length; j++) {
          if (
            cartInfo.items[i].discount &&
            cartInfo.items[i].discount.campaignid
          ) {
            let discountExpired = true;
            for (let disN = 0; disN < menu[j].items.length; disN++) {
              if (
                menu[j].items[disN].discount &&
                menu[j].items[disN].discount.campaignid &&
                cartInfo.items[i].id == menu[j].items[disN].id
              ) {
                discountExpired = false;
              }
            }
            cartInfo.items[i].discountExpired = discountExpired;
            // console.log("@@@@@@@@@@@@@@",discountExpired)
          }

          if (menu[j].id == cartInfo.items[i].categoryId) {
            //分类相同
            // console.log(menu[j].id)

            cartInfo.items[i].productName = menu[j].name;

            for (let k = 0; k < menu[j].items.length; k++) {
              if (cartInfo.items[i].id == menu[j].items[k].id) {
                //口味相同

                cartInfo.items[i].discount = menu[j].items[k].discount;
                cartInfo.items[i].itemname = menu[j].items[k].name;
                cartInfo.items[i].price = menu[j].items[k].price;
                // console.log(22222222222222,cartInfo.items[i].price)
                if (!menu[j].items[k].modifierGroup) break;
                for (
                  let mg = 0;
                  mg < menu[j].items[k].modifierGroup.length;
                  mg++
                ) {
                  // console.log(3333333)
                  //遍历menu列表中的modifierGroup
                  for (let m = 0; m < cartInfo.items[i].modifiers.length; m++) {
                    // console.log(44444444)
                    //遍历购物车中modifiers
                    if (
                      cartInfo.items[i].modifiers[m].groupId ==
                      menu[j].items[k].modifierGroup[mg].id
                    ) {
                      // console.log(m)
                      cartInfo.items[i].modifiers[m].max =
                        menu[j].items[k].modifierGroup[mg].max;
                      cartInfo.items[i].modifiers[m].min =
                        menu[j].items[k].modifierGroup[mg].min;
                      cartInfo.items[i].modifiers[m].groupname =
                        menu[j].items[k].modifierGroup[mg].name;
                      cartInfo.items[i].modifiers[m].groupName =
                        menu[j].items[k].modifierGroup[mg].name;
                      cartInfo.items[i].modifiers[m].max =
                        menu[j].items[k].modifierGroup[mg].max;
                      // console.log(55555)
                      for (
                        let ms = 0;
                        ms <
                        menu[j].items[k].modifierGroup[mg].modifiers.length;
                        ms++
                      ) {
                        if (
                          cartInfo.items[i].modifiers[m].id ==
                          menu[j].items[k].modifierGroup[mg].modifiers[ms].id
                        ) {
                          // console.log(6666)
                          cartInfo.items[i].modifiers[m].price =
                            menu[j].items[k].modifierGroup[mg].modifiers[
                              ms
                            ].price;
                          cartInfo.items[i].modifiers[m].name =
                            menu[j].items[k].modifierGroup[mg].modifiers[
                              ms
                            ].name;
                          break;
                        }
                      }
                    }
                  }
                  for (
                    let nm = 0;
                    nm < cartInfo.items[i].newModifiers.length;
                    nm++
                  ) {
                    //遍历购物车中newModifiers
                    if (
                      cartInfo.items[i].newModifiers[nm].groupId ==
                      menu[j].items[k].modifierGroup[mg].id
                    ) {
                      cartInfo.items[i].newModifiers[nm].groupName =
                        menu[j].items[k].modifierGroup[mg].name;
                      cartInfo.items[i].newModifiers[nm].max =
                        menu[j].items[k].modifierGroup[mg].max;
                      cartInfo.items[i].newModifiers[nm].min =
                        menu[j].items[k].modifierGroup[mg].min;
                      for (
                        let ai = 0;
                        ai < cartInfo.items[i].newModifiers[nm].arr.length;
                        ai++
                      ) {
                        for (
                          let mmm = 0;
                          mmm <
                          menu[j].items[k].modifierGroup[mg].modifiers.length;
                          mmm++
                        ) {
                          if (
                            cartInfo.items[i].newModifiers[nm].arr[ai].id ==
                            menu[j].items[k].modifierGroup[mg].modifiers[mmm].id
                          ) {
                            cartInfo.items[i].newModifiers[nm].arr[ai].price =
                              menu[j].items[k].modifierGroup[mg].modifiers[
                                mmm
                              ].price;
                            cartInfo.items[i].newModifiers[nm].arr[ai].name =
                              menu[j].items[k].modifierGroup[mg].modifiers[
                                mmm
                              ].name;
                            break;
                          }
                        }
                      }
                    }
                  }
                }
                break;
              }
            }
            break;
          }
        }
      }
      // this.$loading().close();
      if (cartInfo && cartInfo.items && cartInfo.items.length > 0) {
        for (let i = cartInfo.items.length - 1; i >= 0; i--) {
          if (cartInfo.items[i].discountExpired) {
            cartInfo.items.splice(i, 1);
            // console.log(22222222222222223333)
          }
        }
      }

      this.cartInfo = cartInfo;
      return cartInfo;
    },
    addNewarrData(items, oldData) {
      if (!items) return;
      for (let i = 0; i < items.length; i++) {
        items[i].isCheck = true;
        if (items[i].modifiers) items[i].newModifiers = [];
        for (let j = 0; j < items[i].modifiers.length; j++) {
          let flag = false;
          for (let k = 0; k < items[i].newModifiers.length; k++) {
            if (
              items[i].newModifiers[k].groupId == items[i].modifiers[j].groupId
            ) {
              let o = {
                id: items[i].modifiers[j].id,
                name: items[i].modifiers[j].name,
                price: items[i].modifiers[j].price,
                quantity: items[i].modifiers[j].quantity,
                gIcon: items[i].modifiers[j].gIcon,
                isSelect: true,
                realTime: items[i].modifiers[j].realTime,
              };
              items[i].newModifiers[k].arr.push(o);
              flag = true;
              break;
            }
          }
          if (!flag) {
            // console.log(items);
            let length = items[i].newModifiers.length;
            items[i].newModifiers[length] = {
              groupId: items[i].modifiers[j].groupId,
              groupName: items[i].modifiers[j].groupName,
              min: items[i].modifiers[j].min,
              max: items[i].modifiers[j].max,
              arr: [
                {
                  id: items[i].modifiers[j].id,
                  name: items[i].modifiers[j].name,
                  price: items[i].modifiers[j].price,
                  quantity: items[i].modifiers[j].quantity,
                  gIcon: items[i].modifiers[j].gIcon,
                  isSelect: true,
                  realTime: items[i].modifiers[j].realTime,
                },
              ],
            };
          }
        }
      }
      if (oldData) {
        oldData.items = items;
        this.cartInfo = oldData;
      }

      this.computeFlavor(items);
      // console.log(12312312123312,items);
      return items;
    },
    computeFlavor(items) {
      if (!items) return items;
      items.forEach(function (ele) {
        if (ele.newModifiers && ele.newModifiers.length > 0) {
          ele.newModifiers.forEach(function (ele2) {
            let quantity = 0;
            ele2.arr.forEach(function (ele3) {
              quantity += ele3.quantity;
            });
            ele2.quantity = quantity;
          });
        }
      });
      return items;
    },
    checkData(
      menu,
      menuIndex,
      pindex,
      modifierGroup,
      orderstoreid,
      combProduct,
      selectParams,
      globalDataUrlParams
    ) {
      let that = this;
      // console.log("that.globalDataUrl",this.globalDataUrl)
      // let menu=this.menu;
      // let menuIndex=this.menuIndex;
      // let pindex=this.pindex;
      // let modifierGroup=this.modifierGroup;
      // console.log("this", that.globalDataUrl, globalDataUrlParams);
      let arr = [];
      if (modifierGroup) {
        let length = modifierGroup.length || Object.keys(modifierGroup).length;
        // console.log("modifierGroup",Object.keys(modifierGroup).length,length);
        for (var i = 0; i < length; i++) {
          modifierGroup[i].modifiers.forEach(function (element) {
            if (element.selectNumber && element.selectNumber > 0) {
              let obj = {
                groupId: modifierGroup[i].id,
                groupName: modifierGroup[i].name,
                groupname: modifierGroup[i].name,
                min: modifierGroup[i].min,
                max: modifierGroup[i].max,
                id: element.id,
                name: element.name,
                price: element.price,
                quantity: element.selectNumber,
                gIcon:
                  (that.globalDataUrl || globalDataUrlParams) + element.image,
                img: (that.globalDataUrl || globalDataUrlParams) + element.image,
                realTime: element.realTime,
              };
              arr.push(obj);
            }
          });
        }
      }
      if (selectParams) {
        var { combPackageId, combPackageGroupKey, combPackageGroupName,combPackageQuantity } =
          selectParams;
      }
      // console.log(`output->combProduct`,combProduct)
      // alert(combProduct)
      let obj = {
        storeId: orderstoreid || this.storeObj.orderstoreid,
        items:
          !menu && combProduct
            ? [
                {
                  campaigndiscount: 0,
                  discount: combProduct.selectProduct.discount,
                  campaignid: combProduct.selectProduct.discount
                    ? combProduct.selectProduct.discount.campaignid
                    : null,
                  campaignname: combProduct.selectProduct.discount
                    ? combProduct.selectProduct.discount.campaignname
                    : null,
                  categoryId: combProduct.selectProduct.categoryid,
                  id: combProduct.selectProduct.id,
                  itemname: combProduct.selectProduct.name,
                  price: combProduct.selectProduct.price,
                  productName: combProduct.selectProduct.categoryname,
                  quantity: 1,
                  remark: null,
                  modifiers: arr,
                  pIcon:
                  (that.globalDataUrl ||
                    globalDataUrlParams) + combProduct.selectProduct.image,
                  img:
                  (that.globalDataUrl ||
                    globalDataUrlParams) + combProduct.selectProduct.image,
                  combPackageId,
                  combPackageGroupKey,
                  combPackageGroupName,
                  combPackageQuantity:1
                },
              ]
            : [
                {
                  campaigndiscount: 0,
                  discount: menu[menuIndex].items[pindex].discount,
                  campaignid: menu[menuIndex].items[pindex].discount
                    ? menu[menuIndex].items[pindex].discount.campaignid
                    : null,
                  campaignname: menu[menuIndex].items[pindex].discount
                    ? menu[menuIndex].items[pindex].discount.campaignname
                    : null,
                  categoryId: menu[menuIndex].id,
                  id: menu[menuIndex].items[pindex].id,
                  itemname: menu[menuIndex].items[pindex].name,
                  price: menu[menuIndex].items[pindex].price,
                  productName: menu[menuIndex].name,
                  quantity: 1,
                  remark: null,
                  modifiers: arr,
                  pIcon:
                  (that.globalDataUrl||
                    globalDataUrlParams) + menu[menuIndex].items[pindex].image,
                  img: (that.globalDataUrl||
                    globalDataUrlParams) + menu[menuIndex].items[pindex].image,
                },
              ],
      };
      // console.log("obj", obj);
      return obj;
    },
    checkSame(newData,cartInfo,isComb=false){
      // if(isComb)var combFlag=true;
      //isComb参数判断comb商品与购物车中是否相同，isComb为true，不做数据合并处理，禁止在函数中修改isComb
      console.log("newData",JSON.stringify(newData))
      console.log("cartInfo",JSON.stringify(cartInfo))
      // let cartInfo=this.cartInfo;
      let copyInfo=JSON.parse(JSON.stringify(cartInfo))
      if(JSON.stringify(cartInfo)==="{}"||JSON.stringify(cartInfo)==="[]"||!cartInfo){//购物车为空
        // if(isComb){combFlag=false;return combFlag;}
        copyInfo=newData;
      }else{
        let result=this.checkDiscountInCart(newData,cartInfo);
        if(!result){
          alert("Not valid with any other promotions")
          return false
        }
        // console.log("新加数据",newData.items)
        // console.log("购物车数据",cartInfo.items)
        for(let i=0;i<newData.items.length;i++){//遍历新数据,判断第一层
          let flagItems=true;
          for(let ii=0;ii<cartInfo.items.length;ii++){//遍历原购物车数据，判断第一层
            if(cartInfo.items[ii].combPackageGroupKey==newData.items[i].combPackageGroupKey&&cartInfo.items[ii].categoryId==newData.items[i].categoryId && cartInfo.items[ii].id==newData.items[i].id && newData.items[i].modifiers.length==cartInfo.items[ii].modifiers.length){
                //分类、ID、属性长度都相同，对比属性
                let flag=true;
                for(let j=0;j<cartInfo.items[ii].modifiers.length;j++){
                  //循环规格
                  // console.log(cartInfo.items[ii].modifiers[j].id,newData.items[i].modifiers[j].id)
                  if(cartInfo.items[ii].modifiers[j].groupId !=newData.items[i].modifiers[j].groupId || cartInfo.items[ii].modifiers[j].id != newData.items[i].modifiers[j].id){
                    //如果规格不同，就跳出循环
                    
                    flag=false;
                    break;
                  }
                }
                if(flag){//完全相同，添加数量
                  // if(isComb){combFlag=false;break;}//跳出函数，阻止合并购物车中数据
                  copyInfo.items[ii].quantity+=newData.items[i].quantity;
                  if(cartInfo.items[ii].combPackageId)copyInfo.items[ii].combPackageQuantity+=newData.items[i].combPackageQuantity;
                  flagItems=false;
                }
                // break;
            //     if(!flag)copyInfo.items.push(newData.items[i]);
            }
          }
          if(flagItems){//无重复商品，直接添加至购物车
            // if(isComb){combFlag=false;break;}//跳出函数，阻止合并购物车中数据
            for(let ii=0;ii<cartInfo.items.length;ii++){
              let cDiscount=cartInfo.items[ii].discount;
              let nDiscount=newData.items[i].discount   
              if(!nDiscount||!cDiscount)break;
              let interFlag=this.hasIntersection(cDiscount,nDiscount);
              if(!interFlag){
                alert("You cannot add a different hot deal item in the cart with different pick up time period. Please place a separate order!");
                return false;
              }
            }
            copyInfo.items.push(newData.items[i])
          }
        }
      }         
      // if(isComb){return combFlag;}
      // console.log("copyInfo.items,copyInfo",copyInfo.items,copyInfo)
      copyInfo.items=this.addNewarrData(copyInfo.items,copyInfo)
      cartInfo=copyInfo;
      // console.log(`output->checkSame`,cartInfo)
      return cartInfo;
    },
    hasIntersection(d1, d2) {
      let haomiaoNow=new Date().getTime();
      if(new Date(d1.pickupenddate)<haomiaoNow  || new Date(d2.pickupenddate)<haomiaoNow || d1.multiredeem !=1 || d2.multiredeem !=1)return false;

      let time1Start = d1.pickupstartdate&&d1.pickupstartdate!="0000-00-00"?(new Date(d1.pickupstartdate)>haomiaoNow?new Date(d1.pickupstartdate):haomiaoNow) : -Infinity;
      let time1End = d1.pickupenddate&&d1.pickupenddate!="0000-00-00"?new Date(d1.pickupenddate) : Infinity;
      let time2Start = d2.pickupstartdate&&d2.pickupstartdate!="0000-00-00"?(new Date(d2.pickupstartdate)>haomiaoNow?new Date(d2.pickupstartdate):haomiaoNow) : -Infinity;
      let time2End = d2.pickupenddate&&d2.pickupenddate!="0000-00-00"?new Date(d2.pickupenddate) : Infinity;

      if (time1End < time2Start || time1Start > time2End ) {        
        return false;
      }
      return true;
    },
    checkDiscountInCart(newData, cartInfo) {
      let flag1 = true,
        flag2 = true;
      for (let i = 0; i < cartInfo.items.length; i++) {
        if (
          cartInfo.items[i].discount &&
          cartInfo.items[i].discount.multiredeem == 0
        ) {
          flag1 = false;
          break;
        }
      }
      for (let i = 0; i < newData.items.length; i++) {
        if (
          newData.items[i].discount &&
          newData.items[i].discount.multiredeem == 0
        ) {
          flag2 = false;
          break;
        }
      }
      if (!flag1 && !flag2) {
        return false;
      } else {
        return true;
      }
    },
    setCartEmpty(cart) {
      return new Promise((resolve, reject) => {
        let cartInfo = cart ? cart : {};
        this.$http.Post("mobile/cart", cartInfo).then(
          (res) => {
            if (res.code == 1) {
              this.cartInfo = cartInfo;
              resolve();
              this.$emit("cartInfoFn", cartInfo);
            } else {
              alert(res.msg);
            }
          },
          (err) => {
            console.log(err);
          }
        );
      });
    },
    checkOut() {
      this.checkOutArr = [];
      let that = this;
      let cartInfo = JSON.parse(JSON.stringify(this.cartInfo));
      let flag = true;
      try {
        cartInfo.items.forEach((ele, index) => {
          ele.newModifiers.forEach((nEle) => {
            let n = 0;
            nEle.arr.forEach((aEle, index) => {
              if (aEle.isSelect) {
                n += aEle.quantity;
              } else {
                nEle.arr[index] = [];
              }
            });

            if (n > ele.quantity * nEle.max) {
              alert(
                cartInfo.items[index].productName +
                  " " +
                  nEle.groupName +
                  " upper limit"
              );
              flag = false;
              this.checkOutArr = [];
              throw "超出上限";
            }
          });

          if (ele.isCheck) {
            ele.newModifiers.forEach((nEle) => {
              for (let i = 0; i < nEle.arr.length; i++) {
                // console.log(nEle.arr[i])
                if (nEle.arr[i] && nEle.arr[i].length == 0) {
                  nEle.arr.splice(i, 1);
                  i--;
                }
              }
            });
            ele.cartIndex = index;
            this.checkOutArr.push(ele);
            // console.log(this.checkOutArr);
          }
        });
      } catch (e) {
        console.log(e, "e");
      }

      if (!flag) return;
      let obj = {
        storemerchantcode: this.storeObj.orderstoreid,
        pickuptime: new Date(),
        items: this.checkOutArr,
      };
      this.$loading();
      this.$http.Post("mobile/checkorder", obj).then(
        (res) => {
          that.$loading().close();
          if (res.code == 1) {
            this.orderBoolean = true;
            this.cartBoolean = false;
            this.discountCode = "";
            this.doDiscountListFn();
            this.getStoreTime();
            that.braze.logCustomEvent("Checkout complete", {
              Timestamp: new Date(),
            });
          } else {
            alert(res.msg);
          }
        },
        (err) => {
          that.$loading().close();
          alert(err.msg);
        }
      );
    },
    GetDiscountList() {
      let that = this;
      let getTimezoneOffset = -new Date().getTimezoneOffset() / 60;
      this.$http
        .Get(
          "mobile/discount?storemerchantcode=" + this.storeObj.orderstoreid,
          "",
          { "Time-zone": getTimezoneOffset }
        )
        .then(
          (res) => {
            if (res.code == 1) {
              that.discountList = res.list;
            } else {
              // alert(res.msg);
            }
          },
          (err) => {
            alert(err.msg);
          }
        );
    },
    doDiscountListFn() {
      let checkOutArr = this.checkOutArr;
      let discountList = this.discountList;
      let allPrice = 0;
      let allNumber = 0;
      


      for (let i = 0; i < discountList.length; i++) {
        if(this.orderDisCan==2||this.orderDisCan==1&&discountList[i].multiredeem!=1){
          discountList[i].canUse = false;
          this.discountListCan=false;
          break;
        }
        let f1 = false,
          f2 = false,
          f3 = false,
          f4 = false;
          
        if (
          discountList[i].billcondition &&
          discountList[i].billcondition.length > 0
        ) {
          for (let j = 0; j < discountList[i].billcondition.length; j++) {
            if (f1 && f2 && f3 && f4) break;

            for (let k = 0; k < checkOutArr.length; k++) {
              if (f1 && f2 && f3 && f4) break;
              allPrice += checkOutArr[k].price * checkOutArr[k].quantity;
              allNumber += checkOutArr[k].quantity;
              if (
                discountList[i].billcondition[j].itemid &&
                discountList[i].billcondition[j].itemid == checkOutArr[k].id
              ) {
                f1 = true;
              }
              if (
                !f2 &&
                discountList[i].billcondition[j].modifiers &&
                discountList[i].billcondition[j].modifiers.length > 0
              ) {
                for (let nj = 0; nj < checkOutArr[k].modifiers.length; nj++) {
                  if (
                    discountList[i].billcondition[j].modifiers.indexOf(
                      checkOutArr[k].modifiers[nj].id
                    ) != -1
                  ) {
                    f2 = true;
                    break;
                  }
                }
              }
            }

            if (allPrice >= discountList[i].billcondition[j].reqamount)
              f3 = true;
            if (allNumber >= discountList[i].billcondition[j].reqquantity)
              f4 = true;
          }
        } else {
          f1 = true;
          f2 = true;
          f3 = true;
          f4 = true;
        }
        console.log(55555555555,f1,f2,f3,f4)
        if (f1 && f2 && f3 && f4) {
          discountList[i].canUse = true;
          this.discountListCan=true;
        } else {
          discountList[i].canUse = false;
          this.discountListCan=false;
        }
     
      }
      this.$forceUpdate();
    },
    getuserinfoFn() {
      let that = this;
      if (this.isLogin != 1) return;
      let u = localStorage.getItem("userinfo");
      if (u && u != "undefined") {
        this.userinfo = JSON.parse(u);
        this.gotUserinfo = JSON.parse(u);
      }

      if (this.userinfo && this.userinfo.QrCode) {
        tracking.setId(that, that.userinfo.QrCode);
        return;
      }
      this.$http.Get("mobile/userinfo", {}).then(
        (res) => {
          if (res.code == 1) {
            if (res.userinfo && res.userinfo.nickname) {
              that.getMenberQr();
              that.userinfo = res.userinfo;
              that.gotUserinfo = res.userinfo;
              this.$emit("userinfo", res.userinfo);
              that.$forceUpdate();
            } else {
              that.isLogin = 0;
            }

            localStorage.setItem("userinfo", JSON.stringify(res.userinfo));
          } else {
            // debugger
          }
        },
        (err) => {}
      );
    },
    getMenberQr() {
      let that = this;
      // console.log(this.userinfo);
      this.$http.Get("mobile/memberqr", {}).then(
        (res) => {
          // console.log(res);
          if (res.QrCode) {
            tracking.userInfo(that, this.userinfo);
            tracking.setId(that, res.QrCode);
          }
        },
        (err) => {}
      );
    },
    logout() {
      this.cartInfo = {};
      this.userPtsObj = "";
      this.userinfo = "";
      // this.isLogin = 3;

      this.$emit("changeLoginStatus", 3);
      localStorage.removeItem("UserId");
      localStorage.removeItem("userinfo");
      localStorage.removeItem("AccessToken");
      localStorage.removeItem("randomUserId");
      localStorage.removeItem("randomToken");
      localStorage.removeItem("randomNumber");
      tracking.setId(this, "");
      this.isLogin = 0;
      this.$router.replace(
        {
          path: "/chooseLocation",
        },
        () => {}
      );
    },
    submit() {
      this.timeObj;
      if (!this.timeObj || !this.timeObj.date || !this.timeObj.time) {
        alert("Please pickup time!");
        return;
      }
      this.$loading();
      let obj = {
        storemerchantcode: this.storeObj.orderstoreid,
        pickuptime: new Date(
          this.timeObj.date + " " + this.timeObj.time
        ).toJSON(),
        // pickuptime:"2022-09-28T16:00:00.000Z",
        items: this.checkOutArr,
        remark: this.areaMark,
      };
      if (this.codeDiscount) {
        obj.billdiscountcode = this.codeDiscount.code;
        obj.billcampaignname = this.codeDiscount.campaignname;
        obj.billcampaignid = this.codeDiscount.campaignid;
        obj.billcampaigndiscount = parseFloat(
          (this.price - this.discountPrice).toFixed(2)
        );
      } else if (this.discountSelectObj) {
        obj.billcampaignname = this.discountSelectObj.campaignname;
        obj.billcampaignid = this.discountSelectObj.campaignid;
        obj.billcampaigndiscount = parseFloat(
          (this.price - this.discountPrice).toFixed(2)
        );
      }
      // console.log(obj.billcampaigndiscount);
      let that = this;
      this.$http.Post("mobile/order", obj).then(
        (res) => {
          // console.log(res);
          if (res.code == 1) {
            // console.log(obj)
            // return
            // res.orderid;
            that.orderid = res.orderid;
            that.getPaymentId(res.orderid).then((data) => {
              setTimeout(() => {
                localStorage.setItem("submit", 1);
                if(that.discountPrice===0){
                  that.freePay(res)
                }else{
                  that.pay(res);
                }
                
              }, 200);
            });

            // this.$router.push({
            //   name: "orderSuccess",
            //   params: {
            //     data: res,
            //     timeObj: that.timeObj,
            //     storeObj: that.storeObj,
            //   },
            // });
          } else if (res.code == -19) {
            that.timeObj = { date: "", time: "" };
            that.getStoreTime().then((res) => {
              // that.pickerOptions()
            });

            that.$loading().close();
          } else {
            alert(res.msg);
            that.$loading().close();
          }
        },
        (err) => {
          that.$loading().close();
          // console.log(err);
          alert(err.msg);
        }
      );
    },
    deleteSelectedCart() {
      let that = this;
      this.cartInfo.items.forEach(function (ele, index) {
        if (ele.isCheck) {
          that.cartInfo.items.splice(index, 1);
        }
      });
      let obj =
        this.cartInfo && this.cartInfo.items && this.cartInfo.items.length > 0
          ? this.cartInfo
          : {};
      this.setCartEmpty(obj);
      this.$forceUpdate();
    },
    getPaymentId(orderid) {
      let that = this;
      return new Promise((resolve, reject) => {
        this.$http
          .Get("pay/eghl/refleshpaymentid?orderid=" + orderid)
          .then((res) => {
            if (res.code == 1) {
              // console.log(res);
              that.orderid = res.paymentid; //"19028758273348979119"
              resolve(res.paymentid);
            }
          });
      });
    },
    sha256(HashKey) {
      let sha256 = require("js-sha256").sha256; //这里用的是require方法
      // console.log(HashKey)
      let password = sha256(HashKey); //要加密的密码
      // console.log(password)//这就是你加密之后的密码
      return password;
    },
    freePay(data){
      let that=this;
        this.$http
          .Get("mobile/payfree?orderid=" + data.orderid)
          .then((res) => {
            // console.log(res)
            if (res.code == 1) {
             that.$router.push({
              name: "orderSuccess",
              query: {
                orderid: data.orderid,
              },
            });
            }else{
              alert(res.msg)
              that.$loading().close();
            }
          });
    },
    pay(data) {
      this.cartBoolean = false;
      let userinfo = this.userinfo;
      let that = this;
      let Password = this.payPassword;
      let reUrl = this.payreUrl;

      // console.log(this.discountPrice);
      let ServiceID = "GCO",
        PaymentID = data.orderid,
        MerchantReturnURL = this.globalDataUrl + "pay/eghl/returnurl",
        MerchantCallBackURL = this.globalDataUrl + "pay/eghl/callback",
        Amount =
        this.discountPrice==0 || this.discountPrice 
            ? this.discountPrice
            : this.price.toFixed(2),
        CurrencyCode = "MYR",
        PageTimeout = "600";
      Amount = parseFloat(Amount).toFixed(2);

      // console.log(111, Amount);
      // debugger
      // return;
      this.MerchantReturnURL = MerchantReturnURL;
      this.MerchantCallBackURL = MerchantCallBackURL;
      this.orderid = data.orderid;
      let hCode =
        Password +
        ServiceID +
        PaymentID +
        MerchantReturnURL +
        MerchantCallBackURL +
        Amount +
        CurrencyCode +
        PageTimeout;

      this.hashCode = this.sha256(hCode);

      // setTimeout(() => {
      //   that.$loading().close()
      // }, 3000);

      setTimeout(() => {
        document.getElementById("form").submit();
      }, 200);
    },

    getYMD(time, n = 0) {
      let d = new Date(new Date(time).getTime() + 86400000 * n);
      return d.getFullYear() + "/" + (d.getMonth() + 1) + "/" + d.getDate();
    },
    pickerOptions() {
      return {
        disabledDate: (time) => {
          let that = this;
          // if (this.codeDiscount && this.codeDiscount.pickupstartdate) {
          //   return (
          //     time.getTime() <
          //       new Date(this.codeDiscount.pickupstartdate).getTime() ||
          //     time.getTime() >
          //       new Date(this.codeDiscount.pickupenddate).getTime()
          //   );
          // }
          let curDate =
            this.serveTime.openatHaomiao > this.serveTime.haomiao
              ? this.serveTime.openatHaomiao
              : this.serveTime.haomiao;
          // let curDate = this.serveTime.openatHaomiao+1800000;
          let number = 2; //时间范围 ，单位：天
          let dayNumber = number * 24 * 3600 * 1000;
          let threeDays = curDate + dayNumber;
          let checkOutArr = this.checkOutArr;
          let pickupstartHaomiao, pickupendHaomiao;
          for (let i = 0; i < checkOutArr.length; i++) {
            if (checkOutArr[i].discount) {
              let startDate = this.$DateFormat(
                checkOutArr[i].discount.pickupstartdate,
                "yyyy-MM-dd HH:mm:ss"
              );
              let endDate = this.$DateFormat(
                checkOutArr[i].discount.pickupenddate,
                "yyyy-MM-dd HH:mm:ss"
              );
              let sd = startDate.split(" ")[0],
                sdTime = startDate.split(" ")[1];
              let ed = endDate.split(" ")[0],
                edTime = endDate.split(" ")[1];

              let haomiaoStart, haomiaoEnd;
              if (sd != null && sd != "" && sd != "0" && sd != "0000-00-00") {
                let t =
                  new Date(
                    sd + " " + that.isWeekendTime(sd).timeOpen
                  ).getTime() > new Date(sd + " " + sdTime).getTime()
                    ? sd + " " + that.isWeekendTime(sd).timeOpen
                    : sd + " " + sdTime;
                haomiaoStart = new Date(t).getTime();
                haomiaoStart = haomiaoStart > curDate ? haomiaoStart : curDate;
              } else {
                haomiaoStart = new Date(
                  that.serveTime.ymd +
                    " " +
                    that.isWeekendTime(that.serveTime.ymd).timeOpen
                ).getTime();
              }

              if (ed != null && ed != "" && ed != "0" && ed != "0000-00-00") {
                let t =
                  new Date(
                    ed + " " + that.isWeekendTime(ed).timeEnd
                  ).getTime() > new Date(ed + " " + edTime).getTime()
                    ? ed + " " + edTime
                    : ed + " " + that.isWeekendTime(ed).timeEnd;
                let ad = new Date(t).getTime(); //discount的结束时间
                haomiaoEnd =
                  ad > haomiaoStart + dayNumber ? haomiaoStart + dayNumber : ad;
              } else {
                haomiaoEnd = haomiaoStart + dayNumber;
              }
              pickupstartHaomiao = haomiaoStart;
              pickupendHaomiao = haomiaoEnd;
              break;
            }
          }
          let startTime = !pickupstartHaomiao ? curDate : pickupstartHaomiao;
          let endTime = !pickupendHaomiao ? threeDays : pickupendHaomiao;

          if (startTime > endTime) return true; //全都不能选
          
          if(this.canSelectDateAndTime){
            let start=curDate > this.canSelectDateAndTime.start?(curDate - 8.64e7):this.canSelectDateAndTime.start;
            let end = curDate > this.canSelectDateAndTime.end?0:this.canSelectDateAndTime.end;
            return (
              time.getTime() < start || time.getTime() > end
            );
          }
          return (
            time.getTime() < startTime - 8.64e7 || time.getTime() > endTime
          );
        },
      };
    },

    computedPrice(ele, price) {
      // console.log(ele, price);
      let gotPrice = price;
      if (!ele) return;
      let originalPrice = 0;
      if (ele.discount && JSON.stringify(ele.discount) != "{}") {
        let discountmothod = ele.discount.discountmothod;
        let discountamount = ele.discount.discountamount;
        if (!gotPrice) {
          //如果没有手动传入价格，循环出sku中的价格+产品价格
          price = ele.price;
          // for(let i=0;i<ele.newModifiers.length;i++){
          //   for(let j=0;j<ele.newModifiers[i].arr.length;j++){
          //     price+=ele.newModifiers[i].arr[j].price*ele.newModifiers[i].arr[j].quantity
          //   }
          // }
        }
        originalPrice = price;
        if (price < ele.discount.minamount) {
          alert(
            "Spend minimum RM" +
              ele.discount.minamount +
              " to enjoy " +
              ele.discount.campaignname
          );
          return { price };
        } //小于可用金额，不可用

        if (discountmothod == 0) {
          //满减
          price -= discountamount;
          if (price < 0) price = 0;
        } else if (discountmothod == 1) {
          //折扣
          let discountPrice = (price * (100 - discountamount)) / 100;
          if (ele.discount.maxamount && discountPrice > ele.discount.maxamount)
            discountPrice = ele.discount.maxamount;
          discountPrice = this.$roundAmount(discountPrice.toFixed(2));
          price -= discountPrice;
        }
        // console.log(price);
        //topping要放在discount后面，不打折
        // if(!gotPrice){
        if (ele.newModifiers && ele.newModifiers.length > 0) {
          for (let i = 0; i < ele.newModifiers.length; i++) {
            for (let j = 0; j < ele.newModifiers[i].arr.length; j++) {
              if (ele.newModifiers[i].arr[j].isSelect) {
                price +=
                  ele.newModifiers[i].arr[j].price *
                  ele.newModifiers[i].arr[j].quantity;
                originalPrice +=
                  ele.newModifiers[i].arr[j].price *
                  ele.newModifiers[i].arr[j].quantity;
              }
            }
          }
        }
        // }
      } else {
        price = ele.price;
        for (let i = 0; i < ele.newModifiers.length; i++) {
          for (let j = 0; j < ele.newModifiers[i].arr.length; j++) {
            if (ele.newModifiers[i].arr[j].isSelect)
              price +=
                ele.newModifiers[i].arr[j].price *
                ele.newModifiers[i].arr[j].quantity;
          }
        }
        // price=this.$roundAmount(price);
        originalPrice = price;
        // console.log(price);
      }
      // console.log(originalPrice, price);
      return {
        price: parseFloat(price.toFixed(2)),
        originalPrice: parseFloat(originalPrice.toFixed(2)),
      };
    },
    hasDiscount() {
      let checkOutArr = this.checkOutArr;
      let discountFlag = true;
      for (let i = 0; i < checkOutArr.length; i++) {
        if (checkOutArr[i].discount) {
          discountFlag = false;
          break;
        }
      }
      return discountFlag;
    },
    checkDiscount() {
      let checkOutArr = this.checkOutArr;
      let discountFlag = true;
      for (let i = 0; i < checkOutArr.length; i++) {
        if (
          checkOutArr[i].discount &&
          checkOutArr[i].discount.multiredeem == 0
        ) {
          discountFlag = false;
          break;
        }
      }
      if (!discountFlag) {
        alert("Cannot be used together with the product discount");
      }
      return discountFlag;
    },
    orderDiscount() {
      let checkOutArr = this.checkOutArr;
      let price = this.price;
      let discountPrice=0;

      let discountmothod=this.discountSelectObj.discountmothod,
      discountamount=this.discountSelectObj.discountamount,
      maxamount=this.discountSelectObj.maxamount;

      if (discountmothod == 0) {
        //满减
        discountPrice=this.$roundAmount((price-discountamount).toFixed(2));        
        // if (price < 0) price = 0;
      } else if (discountmothod == 1) {
        //折扣
        discountPrice = ((price * (100 - discountamount)) / 100);
        if (maxamount && discountPrice >maxamount)
          discountPrice =maxamount;
          discountPrice=this.$roundAmount(discountPrice.toFixed(2));
      }
      this.discountPrice=discountPrice;
    },

    selectDiscount(index) {
      if (!this.checkDiscount()) return;
      // console.log(index);
      for (let i = 0; i < this.discountList.length; i++) {
        this.discountList[i].select = false;
      }
      this.discountList[index].select = true;
      this.discountSelectObj = this.discountList[index];
      this.orderDiscount();
      this.$forceUpdate();
      // console.log(this.discountList)
    },
    closeSelectDiscount() {
      for (let i = 0; i < this.discountList.length; i++) {
        this.discountList[i].select = false;
      }
      this.cartInfo={...this.cartInfo}//删除订单优惠后，cartInfo有监听，重新赋值下自己，刷新价格
    },
    getDis() {
      if (!this.canUseDiscount) {
        alert("Not valid with any other promotions");
        this.discountCode = "";
        return;
      }
      let that = this;
      if (!this.discountCode) return;
      if (!this.checkDiscount()) return;
      // this.$loading();
      let getTimezoneOffset = -new Date().getTimezoneOffset() / 60;
      this.$http
        .Get(
          "mobile/discountcode?code=" +
            that.discountCode +
            "&storemerchantcode=" +
            that.storeObj.orderstoreid,
          "",
          { "Time-zone": getTimezoneOffset }
        )
        .then((res) => {
          if (res.code == 1) {
            if (
              !this.hasDiscount() &&
              res.discount &&
              res.discount.multiredeem == 0
            ) {
              alert("Not valid with any other promotions");
              this.discountCode = "";
              return;
            }
            let result = that.checkDiscountMinAndTime(res.discount, that.price);
            if (!result) return;
            that.closeSelectDiscount();
            that.discountSelectObj = "";
            that.discountPrice = null;
            res.discount.code = that.discountCode;
            that.codeDiscount = res.discount;
            
            let allPrice = this.computedPrice(
              { discount: res.discount },
              that.price
            );
            // console.log(`output->res.discount,that.price,allPrice`,res.discount,that.price,allPrice)
            this.discountPrice = allPrice.price;
            this.originalPrice = allPrice.originalPrice;
            //  this.$loading().close();
          } else {
            // this.$loading().close();
            alert(res.msg);
          }
        })
        .catch((err) => {
          that.disCodePop = true;
          // this.$loading().close();
          setTimeout(() => {
            that.disCodePop = false;
          }, 2000);
        });
    },
    checkDiscountMinAndTime(discount, price) {
      // console.log(`output->check`)
      if (discount.minamount > price) {
        alert(
          "Spend minimum RM" +
            discount.minamount +
            " to enjoy " +
            discount.campaignname
        );
        return false;
      }
      let selectTime = new Date(
        this.timeObj.date + " " + this.timeObj.time
      ).getTime();
      let sT = this.$DateFormat(discount.pickupstartdate, "d-M-yyyy");
      let eT = this.$DateFormat(discount.pickupenddate, "d-M-yyyy");
      let text =
        "Opps! The offer is only valid for Pick Ups" +
        (eT ? " between " + sT + " to " + eT : " from " + sT);
        // console.log(11)

      if (discount.pickupstartdate) {
        let startTime = new Date(
          this.$DateFormat(discount.pickupstartdate, null)
        ).getTime();
        if (startTime > selectTime) {
          // console.log(sT);
          alert(text);
          return false;
        }
      }
      if (discount.pickupenddate) {
        let endTime = new Date(
          this.$DateFormat(discount.pickupenddate, null)
        ).getTime();
        if (endTime < selectTime) {
          alert(text);
          return false;
        }
      }
      return true;
    },
    inventory(id) {
      return new Promise((resolve, reject) => {
        // this.$loading()
        this.$http
          .Get(
            "order/inventory?modiferid=" +
              id +
              "&storemerchantcode=" +
              this.storeObj.orderstoreid
          )
          .then((res) => {
            if (res.code == 1) {
              resolve(res);
            }
            // setTimeout(() => {
            //   this.$loading().close();
            // }, 100);
          });
      });
    },
  },
  activated() {
    alert(111);
  },
  created() {
    let that = this;

    this.globalDataUrl = this.$root.globalData.url;
    // console.log("this.globalDataUrl",this.globalDataUrl);
    try {
      this.storeObj = JSON.parse(localStorage.getItem("storeObj"));
    } catch (e) {}

    if (this.onlyUser) {
      this.userPts().then((res) => {
        this.getuserinfoFn();
      });
    } else {
      if (!this.storeObj)
        this.$router.push({ name: "chooseLocation" }, () => {});
      this.getCart().then((res) => {
        this.GetDiscountList();
        this.gotTime();
        this.userPts();
        this.getuserinfoFn();
      });
    }

    var now = new Date();
    this.now = (now.getTime() / 1000 - 86400).toFixed(0);
    this.date = now.getDate(); //得到日期
    var day = now.getDay(); //得到周几
  },
  // beforeDestroy(){
  //   console.log("cart beforeDestroy")
  //   this.$loading().close();
  //   this.cartBoolean=false;
  // },
  // beforeUnload  (to, from, next){
  //   console.log("beforeRouteLeave",111111111)
  //   debugger
  //   next()
  // },
  watch: {
    businessTime:{
      handler:function(){
        let that=this;
        let items=this.cartInfo.items;
        if(!items)return;
        for(let i=0;i<items.length;i++){
          let ele=items[i];
          if(that.businessTime&&ele.discount&&(that.businessTime<ele.discount.starttime||that.businessTime>ele.discount.endtime)){
              ele.isCheck=false;
            }
        }
      },
      deeep:true,
    },

    isLogin: function (val) {
      // console.log(val);
    },
    "timeObj.date": function (val, oldVal) {
      this.timeObj.time = "";

      let isToday = this.checkToday(this.serveTime.ymd, val);

      this.initOpenTime(val);
      this.pickTimeFn(isToday);
    },
    addCartBoolean: function (val) {
      this.cartBoolean = val;
    },
    cartInfoProps: function (val) {
      this.cartInfo = val;
    },
    cartInfo: {
      handler: function (val, oldVal) {
        let price = 0;
        let campaigndiscountPrice = 0;
        let originalPrice = 0;

        let that = this;
        that.chooseArr = [];
        // console.log(val);
        if (val && val.items && val.items.length > 0) {
          val.items.forEach(function (ele, index) {
            let allPrice = that.computedPrice(ele); //金额
            // that.cartPrice.push(allPrice)
            // console.log(allPrice);
            that.$set(that.cartPrice, index, allPrice);
            
            if (ele.isCheck) {
              that.chooseArr.push(ele);
              let oncePrice = ele.price * ele.quantity;

              // console.log(allPrice, 1111111111111111111);
              let discountOncePrice = allPrice.price;
              originalPrice = allPrice.originalPrice * ele.quantity;
              price += discountOncePrice * ele.quantity;
              // console.log(that.$roundAmount(parseFloat((allPrice.originalPrice-allPrice.price).toFixed(2))))
              ele.campaigndiscount = that.$roundAmount(
                parseFloat((allPrice.originalPrice - allPrice.price).toFixed(2))
              );
            }
          });

          this.originalPrice = originalPrice.toFixed(2);
          this.campaigndiscountPrice = this.$roundAmount(
            parseFloat((originalPrice - price).toFixed(2))
          );
          this.price = this.$roundAmount(parseFloat(price.toFixed(2)));
        } else {
          that.price = "0.00";
          that.discountPrice = null;
          that.campaigndiscountPrice = "0.00";
        }
        that.$forceUpdate();
      },
      deep: true,
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.el-date-table td.today span{
  color: #000!important;
  text-decoration: underline;
  font-weight: 100;
}
.disItem{
  -webkit-filter: grayscale(1);
  pointer-events: none;
}
.combBox {
  margin: 7px;
  margin-bottom: 25px;
  border-radius: 5px;
  padding: 10px;
}
.displayNone {
  display: none;
}
.w20Icon {
  width: 20px;
  height: 20px;
}
.btn {
  padding: 15px 0 !important;
  border-radius: 50px !important;
  cursor: pointer;
}
.btnDefalt {
  background: rgb(220, 220, 220);
  color: #666;
  margin-right: 20px;
}
.couponPopover {
  width: 300px;
  right: 0;
}

.overBtn {
  display: none;
}
.popperClass {
  border: 1px solid rgb(216, 90, 162);
  padding: 0;
}

.codeInput {
  border: 2px solid #eee;
  border-radius: 3px;
  line-height: 25px;
}
.payBtn {
  text-align: right;

  width: 80%;
  margin: 0 auto;
  text-align: center;
  border-radius: 50px;
}
.right {
  text-align: right;
}
.totalPrice {
  border-bottom: 1px solid #666;
  color: #666;
  width: 100%;
  padding: 0 15px 10px;
  margin-bottom: 15px;
}
.h100BgBox {
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9;
}
.popcontent a {
  /* border-bottom: 1px solid rgb(216, 90, 162); */

  font-size: 12px;
  color: rgb(216, 90, 162);
  position: relative;
  margin-top: -2px;
  padding: 10px 0;
}
.popcontent a,
.popcontent div {
  color: rgb(216, 90, 162);
  display: block;
  padding: 10px 0;
  /* color:#fff; */
}
.popcontent a::after,
.popcontent div::after {
  content: "";
  height: 1px;
  background: rgb(216, 90, 162);
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 0;
}
.popcontent div:last-child::after {
  content: "";
  height: 0;
}
.popcontent a:hover,
.popcontent div:hover {
  background: rgb(216, 90, 162);
  color: #fff !important;
}
.popcontent:hover {
  color: #fff !important;
}
.popcontent div:last-child::after {
  content: "";
  height: 0px;
}
.cartDrawer {
  width: 500px !important;
  left: initial !important;
  overflow: hidden;
}
@media screen and (max-width: 768px) {
  .cartDrawer {
    width: 100% !important;
  }
  .timeAbs {
    position: absolute !important;
  }
  .el-icon-d-arrow-right:before,
  .el-icon-arrow-right:before,
  .el-icon-arrow-left:before,
  .el-icon-d-arrow-left:before {
    padding: 10px;
  }
}
</style>

<style scoped>
.disBox {
  border: 1px solid #eee;
  border-radius: 5px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
}
.popdiscountBtn {
  border: none;
  width: 100%;
  padding: 0;
  color: #000 !important;
}
.popdiscountBtn:hover {
  color: initial;
  background: initial;
}
.csBtn {
  /* background: rgb(0, 92, 157); */
  /* color: #fff; */
  color: #000;
  border-radius: 5px;
  padding: 5px 15px;
  font-size: 14px;
  text-decoration: underline;
}
.cText {
  font-size: 1.3rem;
}
.pd15 {
  padding: 15px;
}
.detailBtn {
  font-weight: bold;
  border-bottom: 1px solid rgb(216, 90, 162);
}
.cartIcon {
  width: 2rem;
}
.tBox2 {
  display: flex;
  justify-content: space-around;
  /* width: 10rem; */
}
.deleteIcon {
  width: 20px;
  height: 20px;
}

.closeIconTop {
  width: 20px;
  height: 20px;
}
.w25 {
  width: 25px;
}
.arrowIcon {
  width: 10px;
  height: 10px;
}
.cleanIcon {
  width: 20px;
  height: 20px;
}
.cartBox {
  -moz-box-shadow: 0px 0px 9px #9c9c9c;
  -webkit-box-shadow: 0px 0px 9px #9c9c9c;
  box-shadow: 0px 0px 9px #9c9c9c;
  border-radius: 5px;
  position: absolute;
  right: 0;
  border-bottom: 1px solid #eee;
  background: #fff;
  z-index: 9;
  height: calc(100% + 50px);
  width: 100%;
}
.iceIcon {
  width: 2.5rem;
}
.scBox {
  height: 100%;
  overflow-y: scroll;
  padding-bottom: 150px;
  background: rgb(245, 245, 245);
}
.scBox div {
  background: white;
}
.pickBox {
  height: 100%;
}
.maxwidth300 {
  max-width: 300px;
}
.bgBox {
  background: rgb(245, 245, 245);
}
.edit {
  text-decoration: underline;
  padding: 0 20px;
}
.checkoutBtn {
  margin: 0 auto;
  padding: 15px 20px;
  display: block;
  width: 90%;
}
.continueBtn {
  background: #fff;
  border: rgb(216, 90, 162) 1px solid;
  color: rgb(216, 90, 162);
}
.btmBox {
  border-top: 1px solid #eee;
  -moz-box-shadow: 0px -3px 9px #cfcfcf;
  -webkit-box-shadow: 0px -3px 9px #cfcfcf;
  box-shadow: 0px -3px 9px #cfcfcf;
  padding: 15px 0;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 50px;
  background: #fff;
}
.btmDetailBoxLine {
  height: 1px;
  background: #dcdcdc;
}
.pd5 {
  padding: 5px;
  padding-top: 2px;
}
.detailPriceBox {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 15px;
  height: 0;
  overflow: hidden;
}
.detailPriceBoxOpen {
  height: auto;
}
.mr15 {
  margin-right: 15px !important;
}
.cartTopBox {
  border-bottom: 1px solid rgb(165, 165, 165);
  margin: 10px;
  padding: 10px;
}
.contentBox{
  border-radius: 5px;
}
.contentBox,
.nameBox {
  margin: 10px;
  padding: 15px;
  /* margin-bottom: 30px; */
  position: relative;
}
.contentBtmLine {
  width: 110%;
  margin-left: -5%;
  margin-top: 10px;
  background: rgb(241, 241, 241);
  height: 3px;
}
.detailClose {
  position: absolute;
  right: 10px;
  top: -3px;
  width: 30px;
  height: 30px;
}
.color0 {
  color: rgb(164, 164, 164);
}
.contentBox::after {
  content: "";
  width: 100%;
  height: 1px;
  background: #000;
}
.cartNumBox {
  position: absolute;
  left: 20px;
  top: -6px;
  width: 23px;
  height: 23px;
  border: 2px solid #fff;
  color: #fff;
  background: rgb(216, 90, 162);
  border-radius: 50%;
  font-size: 10px;
}
.whiteBg {
  background: #fff;
  padding: 40px;
  width: 50%;
  border-radius: 10px;
}
.w50 {
  display: block;
  width: 50%;
}
.slide-fade-enter-active {
  transition: all 0.2s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(10px);
  opacity: 0;
}
.detailBox {
  background: rgb(245, 245, 245);
  padding: 10px;
  border-radius: 5px;
}
.cakeImg {
  width: 70px;
  height: 70px;
  padding: 2px;
  border: 1px solid #eee;
  border-radius: 3px;
}
.dateInput {
  border: 1px solid #000;
  text-align: center;
  line-height: 2;
  width: 120px;
  border-radius: 3px;
}
.dateInput2 {
  border-bottom: 1px solid #000;
  text-align: left;
  line-height: 1.5;
  width: 120px;
  display: block;
}
.dateInput3 {
  width: 100%;
}
textarea {
  resize: none;
  display: block;
  width: 100%;
  border-bottom: 1px solid #000;
  margin-top: 5px;
}
.popTitle {
  font-size: 1rem;
  font-weight: bolder;
}
.poph1 {
  color: rgb(91, 91, 91);
}
.w25px {
  width: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* .el-input {
  width: 50% !important;
} */
.delBtn {
  border: 1px solid rgb(216, 90, 162);
  border-radius: 5px;
  font-weight: 100;
  font-size: 12px;
  padding: 2px 5px;
  margin-right: 10px;
  pointer-events: auto;
  -webkit-filter: none;
}
.w20 {
  width: 20px;
  height: 20px;
}
.color4 {
  color: #ccc;
}
.popspan1 {
  color: rgb(117, 117, 117);
  width: 300px;
}
.fs18 {
  font-size: 18px;
}
.bgwhite {
  background: #fff;
  border-radius: 8px;
  padding: 10px;
}
.line {
  background: rgb(245, 245, 245);
  height: 1px;
}
.mt4 {
  margin-top: 4px;
}
.okBtn {
  background: #67c23a;
}
.cancelBtn {
  background: #909399;
}
.dateBtn {
  color: white;
  border-radius: 30px;
  line-height: 2;
  width: 90%;
  text-align: center;
}
select {
  padding: 5px 10px;
}
.disabled {
  opacity: 0.3;
  pointer-events: none;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.disClose {
  position: absolute;
  right: 0;
  top: 0;
}
.ro90 {
  transform: rotate(-90deg);
}
.pIcon {
  width: 4rem;
  height: 4rem;
}
.conFlex {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.disabled {
  pointer-events: none;
  opacity: 0.3;
}

.now-data-myself {
  width: 40%;
  position: absolute;
  border-right: 1px solid rgba(227, 227, 227, 0.6);
  text-align: center;
}
.con {
  position: relative;
  width: 100%;
  margin: auto;
  background: #f5f5f5;
  z-index: 9;
}
.con .wh_content_all {
  background: transparent !important;
}
.wh_top_changge li {
  color: #f56c6c !important;
  font-size: 15px !important;
}
.wh_content_item,
.wh_content_item_tag {
  color: #303133 !important;
}
.wh_content_item .wh_isToday {
  background: #00d985 !important;
  color: #fff !important;
}
.wh_content_item .wh_chose_day {
  background: #409eff !important;
  color: #ffff !important;
}
.wh_item_date:hover {
  background: rgb(217, 236, 255) !important;
  border-radius: 100px !important;
  color: rgb(102, 177, 255) !important;
}
.wh_jiantou1[data-v-2ebcbc83] {
  border-top: 2px solid #909399;
  border-left: 2px solid #909399;
  width: 7px;
  height: 7px;
}
.wh_jiantou2[data-v-2ebcbc83] {
  border-top: 2px solid #909399;
  border-right: 2px solid #909399;
  width: 7px;
  height: 7px;
}
.wh_top_tag[data-v-2ebcbc83] {
  color: #409eff;
  border-top: 1px solid rgba(227, 227, 227, 0.6);
  border-bottom: 1px solid rgba(227, 227, 227, 0.6);
}
.wh_container[data-v-2ebcbc83] {
  max-width: 280px;
}
.wh_top_changge[data-v-2ebcbc83] {
  display: flex;
  min-width: 90px;
  margin-left: 43%;
}
.now-data-myself-time {
  color: #f56c6c;
  font-size: 28px;
  height: 30px;
  font-family: "Helvetica Neue";
}
.now-data-myself-week {
  font-size: 10px;
  color: #909399;
}
.wh_top_changge .wh_content_li[data-v-2ebcbc83] {
  font-family: Helvetica;
}
.pb300 {
  padding-bottom: 300px;
}
.wh_content_item .wh_isToday {
  background: none !important;
  color: #303133 !important;
}
.wh_content_item .wh_chose_day.wh_isToday {
  background: #409eff !important;
  color: #ffff !important;
}
.wh_content_item .wh_isToday:hover {
  background: rgb(217, 236, 255) !important;
  border-radius: 100px !important;
  color: rgb(102, 177, 255) !important;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 100%;
}
.numbOx {
  width: 45px;
  text-align: right;
}
.checkoutBtnMobile {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #fff;
  padding: 20px 10%;
}

.checkoutBtn2 {
  width: 50%;
  margin: initial;
  white-space: nowrap;
}
.nowrap {
  white-space: nowrap;
}
.markBox {
  border: 2px solid #eee;
  border-radius: 3px;
  line-height: 25px;
  padding: 10px;
}
@media screen and (max-width: 768px) {
  .scBox {
    height: auto;
    padding-bottom: 100px;
  }
  .cartBoxMobile {
    left: 0;
    position: relative;
  }
  .btmBoxMobile {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
  }
  .scBoxPdBtm {
    padding-bottom: 150px;
  }
  .codeInput {
    width: 150px;
  }
  .w90Mobile {
    width: 90%;
    margin: 0 auto;
  }
  .signWhiteBg {
    background: #fff;
    padding: 5px 0;
  }
  .mWauto {
    width: auto;
  }
  .btmBox {
    padding: 10px 0;
  }
  .totalPrice {
    margin-bottom: 6px;
  }
  .mPd7 {
    padding: 7px;
  }
  .checkoutBtn {
    padding: 10px 0;
  }
  .wrapNameM {
    flex-direction: column;
    align-items: flex-start;
    max-width: 200px;
    white-space: pre-wrap;
  }
  .wrapNameM .csBtn {
    font-size: 12px;
    padding-left: 0;
  }
  .cartBox {
    height: auto;
  }
}
</style>
